import { getPhysic as V, teleportPlayer as At, setThirdPersonStore as te, getThirdPersonStore as z, physicApi as me, usePhysicStore as Qe, useThirdPersonStore as be, offsetScalerMin as _n, offsetScalerMax as In, setPhysic as Tt, ThirdPerson as An, useDynamic as Tn } from "@utsubo/oni";
import { getUser as En } from "@utsubo/experience";
import { emitEvent as g, useEvent as B, onEvent as We, offEvent as $n } from "@utsubo/events";
import { getStoreScene as Dn, shared as W, setStoreRenderer as lt, useDetectDevice as Me, useStoreUbo as Fn, getInteractiveStore as ct, OrbitControls as Un, PerspectiveCamera as Vn, useStoreScene as dt, useLoader as Et, setLoader as Je, setStoreScene as Bn, useSyncFaceTrackingPlayer as Rn, getStateUbo as Nn, useStoreRenderer as $t, OrthographicCamera as Dt, getHeightAnimOffset as On, BubbleWithBorder as zn, Character as Ln, EmojisInstance as Wn, Text as jn, EmojisInstances as qn, Characters as Hn, useGLTFSafe as Gn, BatchInstances as Qn, PhongShader as Jn, TransformControls as Xn, BatchInstance as Kn, useSafeExternalImgUrl as Xe, getSafeExternalImgUrl as Yn, getStoreRenderer as Zn, lightData as _e } from "@utsubo/renderer";
import { shallow as Ie } from "zustand/shallow";
import { create as Ae } from "zustand";
import * as _ from "three";
import { Vector3 as Te, Quaternion as Ft, Vector4 as er, Color as Ut, CameraHelper as tr } from "three";
import * as J from "react";
import { useMemo as Z, useEffect as R, createRef as Vt, useRef as $, useCallback as he, useState as N, Suspense as ut, lazy as nr, forwardRef as rr, useLayoutEffect as Bt } from "react";
import { jsx as l, jsxs as M, Fragment as H } from "react/jsx-runtime";
import { useThree as Ee, useFrame as X, Canvas as or, createPortal as Rt } from "@react-three/fiber";
import { Howl as ir } from "howler";
import $e from "gsap";
import { useGesture as sr } from "@use-gesture/react";
import "@react-three/xr";
import ar from "tunnel-rat";
import { useTranslation as Y } from "@utsubo/i18n";
import { styled as I } from "styled-components";
import ft from "mime-types";
const ee = new Proxy({}, { get(t, n) {
  return "https://cdn.utsubo.io/experience/0-0-246" + (n.startsWith("/") ? n : "/" + n);
} }), lr = (t, n, e = true, r = false, o = () => {
}, i = 1) => {
  const { playerApi: a } = /* @__PURE__ */ V();
  a.teleporting = true;
  const c = () => {
    At(t, n);
  }, d = En().id;
  e ? setTimeout(() => {
    r ? setTimeout(() => {
      g(`anim_holo_tp_${d}`, { teleportingOut: false, duration: i, callBack() {
        a.teleporting = false, o();
      } });
    }, 300) : (a.teleporting = false, o()), g("fadeBlack", false);
  }, 500) : r ? g(`anim_holo_tp_${d}`, { teleportingOut: false, duration: i, callBack() {
    a.teleporting = false, o();
  } }) : (a.teleporting = false, o());
  const s = () => {
    e ? (g("fadeBlack", true), setTimeout(() => {
      c();
    }, 800)) : c();
  };
  r ? g(`anim_holo_tp_${d}`, { teleportingOut: true, duration: i, callBack() {
    s();
  } }) : s();
}, cr = { backward: false, forward: false, left: false, right: false }, pt = /* @__PURE__ */ Ae((t, n) => ({ removeInteractiv: (r) => {
  const { canInteractWith: o } = /* @__PURE__ */ n();
  t({ canInteractWith: o.filter((i) => i.player.playerId !== r) });
}, dom: null, isCinematic: false, askedScreenshot: false, isScreenshot: false, isIdle: false, isAfk: false, isCustomising: false, isAnimPaused: false, canInteractWith: [], disableIdleCamera: false, disableControls: false, disableUI: false, controls: cr, editorMode: false, jumpEnabled: true, flyEnabled: true, slideEnabled: true, playersFirebase: {}, playersRoles: {}, seatsTaken: {}, allMessages: [], usersList: [], usersById: {}, microverseWaitlistLive: [], microverseWhitelistLive: [], microverseGuestsLive: [], totalMessages: 0, startWalkFrom: 2, startRunFrom: 9, lastKnownValidLocation: [], sharedFileView: null, sharedFileEditor: false, sharedFileFocused: false, sharedFiles: [], canInteractWithSeats: true, sceneAudioMute: false })), j = (t, n) => pt(t, n || Ie);
Object.assign(j, pt);
const { getState: E, setState: A } = pt, dr = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
function mt(t) {
  return t < 10 ? `0${t}` : t;
}
const Nt = (t, n) => {
  A((e) => {
    const r = /* @__PURE__ */ new Date(), o = /* @__PURE__ */ r.getHours(), i = /* @__PURE__ */ r.getMinutes(), a = /* @__PURE__ */ r.getSeconds(), c = `${mt(o)}:${mt(i)}:${mt(a)}`;
    e.allMessages.unshift({ key: Date.now(), playerId: n, message: t, sentTime: c }), e.allMessages.length >= 10 && e.allMessages.pop();
    const d = { allMessages: e.allMessages, totalMessages: e.totalMessages + 1 };
    return dr.test(t) && Dn().updateFont("JP"), d;
  });
}, Ot = () => {
  const { defaultSkinColor: t, defaultHeight: n, defaultPerks: e } = W;
  return { skin: { color: [...t], height: n, perks: { ...e }, colors: {} }, defaultSkin: { color: [...t], colors: {}, height: n, perks: { ...e }, collectionadr: null, token_id: null } };
}, zt = { id: "tempId", ref: null, user: null, email: null, messages: [], writingMessage: false, isPassOwner: false, name: "", didtuto: false, muted: true, inChatZone: false, chatZoneId: null, walletCnt: 0, wallets: [], allWallets: [], skins: {} }, ht = /* @__PURE__ */ Ae(() => ({ ...zt, ...Ot(), quaternion: [0, 0, 0, 1], position: [0, 4, 0], signedIn: false, anonymousSession: true, spawning: true, media: { mic: null, speaker: null, camera: null, video: null }, settings: { hideUi: false, camera: { invertX: true, invertY: false }, audio: { mute: false, bgm: 0.6, sfx: 0.8 }, accessibility: { biggerText: false }, privacy: { showNames: true, offline: false, showChat: true, showCharacter: true, alwaysShowChat: false, micEnabled: false, videoEnabled: false, trackingEnabled: false }, sp: { disableAudioChat: false, hideMic: false, muteOthers: false }, pc: { disableAudioChat: false, hideMic: false, muteOthers: false } } })), De = (t, n) => ht(t, n || Ie);
Object.assign(De, ht);
const { getState: O, setState: Fe } = ht, ur = (t, n) => {
  Nt(n, t);
  let e = O().messages;
  e && (e.unshift({ message: n, time: window.performance.now() }), e.length >= 3 && (e = e.slice(0, 3)), Fe({ messages: e }), g(`message_${t}`, { messages: e }));
}, gt = () => {
  te({ isDragging: false });
  const { lockRotation: t, preventReset: n } = /* @__PURE__ */ z();
  if (!t || n)
    return;
  const { moveAlongZ: e, isIdle: r } = /* @__PURE__ */ E();
  if (r || !e)
    return;
  const { sharedCamera: o } = /* @__PURE__ */ V();
  o.resetCamera = true;
};
function yt(t) {
  return { refreshCharacters: t.refreshCharacters + 1 };
}
function wt(t, n, e) {
  t.playersByIds[e] = n, t.playerNeedsUpdt[e] = 0;
}
const xt = /* @__PURE__ */ Ae((t, n) => ({ closestPlayers: [], players: [], npcPlayers: [], clonePlayers: [], playersByIds: {}, playersPerCollection: {}, refreshCharacters: 0, playerNeedsUpdt: {}, playersMeshes: {}, createPlayer: (e, r) => {
  const o = /* @__PURE__ */ n(), { players: i } = o, a = /* @__PURE__ */ i.find((d) => d.playerId === e);
  if (a)
    return a;
  const c = /* @__PURE__ */ Lt(e, r);
  return wt(o, c, e), i.push(c), o.updatePlayerCollection(c), c;
}, addToCollection: (e) => {
  const r = e.perks.collection, { playersPerCollection: o, playerNeedsUpdt: i } = /* @__PURE__ */ n();
  o[r] ? o[r].push(e) : o[r] = [e], i[e.playerId]++, e.currentCollection = r, t({ playersPerCollection: o, playerNeedsUpdt: i });
}, removeFromCollection: (e) => {
  const { currentCollection: r } = e;
  if (!r)
    return;
  const { playersPerCollection: o, playerNeedsUpdt: i } = /* @__PURE__ */ n();
  e.currentCollection = null, o[r].splice(o[r].indexOf(e), 1), o[r].indexOf(e) !== -1 && (i[e.playerId] = { ...i[e.playerId] }, i[e.playerId]++, t({ playersPerCollection: o, playerNeedsUpdt: i }));
}, removePlayer: (e) => {
  const { players: r, playersByIds: o, playerNeedsUpdt: i, removeFromCollection: a, playersMeshes: c } = /* @__PURE__ */ n();
  o[e] && (g("call_player_remove", e), o[e] && a(o[e]), o[e] = void 0, i[e] = void 0, delete c[e], g("remove_player", e), t({ players: r.filter((d) => d.playerId !== e), playersByIds: o, playerNeedsUpdt: i, playersMeshes: c }), t(yt));
}, getPlayerById: (e) => n().playersByIds[e], updatePlayerCollection: (e) => {
  if (e.perks.collection !== e.currentCollection) {
    const { removeFromCollection: r, addToCollection: o, playersByIds: i } = /* @__PURE__ */ n();
    r(e), o(e), i[e.playerId] && t(yt);
  }
} })), ne = (t, n) => xt(t, n || Ie);
Object.assign(ne, xt);
const { getState: re, setState: Ke } = xt, Ue = (t) => {
  Ke((n) => {
    const e = { playerNeedsUpdt: n.playerNeedsUpdt };
    return e.playerNeedsUpdt[t]++, e;
  });
}, Lt = (t, n = {}) => {
  const e = { playerId: t, position: new Te(), quaternion: new Ft(), currentCollection: null, name: "", perks: {}, colors: {}, driving: false, peer: { ignorePeer: false, energy: 0, name: "" }, modelHeight: 1, upVector: new Te(0, 1, 0), setCharacterRef: (r) => {
    Ke((o) => {
      if (o.playersMeshes[t])
        return {};
      const i = { playersMeshes: o.playersMeshes };
      return r ? (i.playersMeshes[t] = { ...i.playersMeshes[t] }, i.playersMeshes[t] = r, i) : (delete i.playersMeshes[t], i);
    });
  }, ...n };
  return n.perks ? e.perks = { ...n.perks } : e.perks = { ...W.defaultPerks }, e;
}, Wt = (t, n) => {
  B(`update_skin_height_${n}`, (e) => {
    t && (t.height = e, Ue(n));
  }), B(`update_skin_color_${n}`, (e) => {
    t && (t.color || (t.color = new _.Vector4(0, 0, 0, 0)), t.color.set(e[0], e[1], e[2], e[3] !== void 0 ? e[3] : 0), Ue(n));
  }), B(`update_skin_colors_${n}`, (e = {}) => {
    t && (t.colors = { ...e }, Ue(n));
  }), B(`update_skin_neonColor_${n}`, (e) => {
    t && (t.neonColor || (t.neonColor = new _.Color()), t.neonColor.setStyle(e), Ue(n));
  }), B(`update_skin_perks_${n}`, (e = {}) => {
    t && (t.perks = { ...e }, Ue(n));
  });
}, vt = /* @__PURE__ */ Ae((t, n) => ({ nonPlayers: [], clonePlayers: [], npcPlayers: [], nonPlayersByIds: {}, createNonPlayer: (e, r) => {
  const { nonPlayers: o } = /* @__PURE__ */ n(), i = /* @__PURE__ */ o.find((c) => c.playerId === e);
  return i || mr(e, r);
}, addNonPlayer: (e) => {
  const { playerId: r } = e, { nonPlayers: o, nonPlayersByIds: i } = /* @__PURE__ */ n();
  o.push(e), i[r] = e, t({ nonPlayers: o, nonPlayersByIds: i });
}, removeNonPlayer: (e) => {
  const { nonPlayers: r, nonPlayersByIds: o } = /* @__PURE__ */ n();
  delete o[e], g("remove_nonplayer", e), t({ nonPlayers: r.filter((i) => i.playerId !== e), nonPlayersByIds: o });
} })), bt = (t, n) => vt(t, n || Ie);
Object.assign(bt, vt);
const { getState: fr, setState: pr } = vt, mr = (t, n = {}) => ({ playerId: t, position: new Te(), quaternion: new Ft(), activPetAnimations: {}, color: new er(W.defaultSkinColor[0], W.defaultSkinColor[1], W.defaultSkinColor[2], W.defaultSkinColor[3]), neonColor: new Ut("#ffffff"), dirVector: new Te(0, 0, 1), upVector: new Te(0, 1, 0), eyePosition: new Te(0, 0, 0), noHeadTracking: false, distToPlayer: 999, name: "", ...n }), hr = (t, n) => {
  const [e, r, o] = /* @__PURE__ */ bt((a) => [a.createNonPlayer, a.addNonPlayer, a.removeNonPlayer]), i = /* @__PURE__ */ Z(() => e(t, n), [t]);
  return R(() => (r(i), () => {
    o(i);
  }), [i]), i;
}, jt = (t, n, e, r) => {
  const [o, i, a, c, d] = /* @__PURE__ */ ne((s) => [s.playersMeshes[t], s.players, s.createPlayer, s.playersByIds[t] && s.playersByIds[t].perks.collection, s.removePlayer]);
  return R(() => {
    const s = /* @__PURE__ */ a(t, n);
    if (e && e(s), Ke((m) => {
      const f = {};
      return m.playersByIds[t] || wt(m, s, t), f.refreshCharacters = m.refreshCharacters + 1, f;
    }), g("playersCountChanged", i.length), !n?.isNpc) {
      const m = E().usersById[s.playerId];
      m && (s.firebase = m);
    }
    return () => {
      r && r(t), d(t), g("playersCountChanged", i.length);
    };
  }, [t]), o;
}, kt = /* @__PURE__ */ Ae((t, n) => ({ inCall: false, privateOn: false, showCallGrid: false, gridFullscreen: false, callMode: "", avatarsContainerRef: Vt(), avatarsContainerRefBack: Vt(), micOffWarning: false, micOffWarningDisplayed: false, currentUserScreenShareActive: false })), Ye = (t, n) => kt(t, n || Ie);
Object.assign(Ye, kt);
const { getState: gr, setState: ke } = kt, yr = ["participants"], wr = (t, n) => (e, r, o) => {
  const i = typeof window < "u" && typeof window.electronBridge < "u" ? window.electronBridge : null;
  let a;
  return typeof n == "function" ? a = n(e, r, o) : a = n, { ...a, isElectron: !!i, set: (d) => {
    if (typeof d == "function") {
      const s = /* @__PURE__ */ d(r());
      e(s);
    } else
      e(d);
    if (i)
      for (const s of t)
        d.hasOwnProperty(s) && i.send(s, r()[s]);
  }, send: (d, s) => {
    i && i.send(d, s);
  }, on: (d, s) => {
    i && i.on(d, (u) => {
      s(u);
    });
  } };
}, Ze = /* @__PURE__ */ Ae(wr(yr, (t, n) => (We("call_player_add", (e) => {
  n().addParticipant(e), console.log("call_player_add", e);
}), We("call_player_remove", (e) => {
  n().removeParticipant(e);
}), We("screenshare_player_add", (e) => {
  n().addScreenShare(e), ke({ currentUserScreenShareActive: O().id === e });
}), We("screenshare_player_remove", (e) => {
  n().removeScreenShare(e), ke({ currentUserScreenShareActive: false });
}), { participants: /* @__PURE__ */ new Map(), screens: /* @__PURE__ */ new Map(), collectionsInCall: {}, addScreenShare: (e) => {
  const { screens: r } = /* @__PURE__ */ n();
  if (e === "tempId")
    return;
  const o = /* @__PURE__ */ re().getPlayerById(e);
  if (o) {
    if (!r.has(e))
      r.set(e, o);
    else
      return;
    t({ screens: r }), ke({ inScreenshare: true });
  }
}, removeScreenShare: (e) => {
  const { screens: r } = /* @__PURE__ */ n();
  e === "tempId" || !re().getPlayerById(e) || (r.has(e) && r.delete(e), n().screens.size < 1 && ke({ inScreenshare: false }));
}, addParticipant: (e) => {
  const { participants: r, collectionsInCall: o } = /* @__PURE__ */ n();
  if (e === "tempId")
    return;
  const i = /* @__PURE__ */ re().getPlayerById(e);
  if (!i)
    return;
  const a = i.currentCollection;
  if (o[a] ? o[a].includes(i) || o[a].push(i) : o[a] = [i], !r.has(e))
    r.set(e, i);
  else
    return;
  t({ participants: r }), n().participants.size > 1 && ke({ inCall: true, callMode: "huddle" }), t({ collectionsInCall: o });
}, updateParticipant: (e) => {
  const { participants: r } = /* @__PURE__ */ n();
  if (e === "tempId")
    return;
  const o = /* @__PURE__ */ re().getPlayerById(e);
  r[e] && t({ participants: { ...r, [e]: o } });
}, removeParticipant: (e) => {
  const { participants: r, collectionsInCall: o } = /* @__PURE__ */ n();
  if (e === "tempId")
    return;
  const i = /* @__PURE__ */ re().getPlayerById(e);
  if (!r[e])
    return;
  const a = i.currentCollection;
  if (o[a]) {
    const d = o[a], s = /* @__PURE__ */ d.indexOf(i);
    s > -1 && d.splice(s, 1), d.length === 0 && delete d[d];
  }
  const c = { ...r };
  delete c[e], t({ participants: c }), n().participants.size < 2 && (ke({ inCall: false, callMode: "closed", showCallGrid: false, gridFullscreen: false, currentUserScreenShareActive: false, micOffWarning: false, micOffWarningDisplayed: false, inScreenshare: false }), lt({ paused: false })), t({ collectionsInCall: o });
} }))), qt = (t, n) => Ze(t, n || Ie);
Object.assign(qt, Ze);
const { getState: je, setState: xr } = Ze, vr = () => {
  const { gl: t } = /* @__PURE__ */ Ee(), n = /* @__PURE__ */ $({ x: 0, y: 0 });
  X(() => {
    const { sharedCamera: e, playerApi: r } = /* @__PURE__ */ V(), { cameraOffsetDefault: o } = /* @__PURE__ */ z();
    r.xAxisMouseCtrl = n.current.x * 0.2, e.cameraOffsety = o.y - n.current.y * 2, n.current.x = 0;
  }), B("fsAimMode", (e) => {
    t.domElement && (e ? t.domElement.requestPointerLock() : document.exitPointerLock());
  }), R(() => {
    const e = (r) => {
      const { movementX: o, movementY: i } = r, a = /* @__PURE__ */ Math.min(Math.max(o, -90), 90), c = /* @__PURE__ */ Math.min(Math.max(-i * 5e-3 + n.current.y, -1), 0.6);
      n.current = { x: a, y: c };
    };
    return t.domElement.addEventListener("mousemove", e), () => {
      t.domElement.removeEventListener("mousemove", e);
    };
  }, [t]);
}, ge = { startPaint: "startPaint", paint: "paint", stopPaint: "stopPaint", jump: "jump", bumper: "bumper", openModal: "openModal", closeModal: "closeModal" }, br = () => Object.keys(ge).map((t) => ({ label: ge[t], value: ge[t] })), kr = () => {
  const t = /* @__PURE__ */ j((n) => n.sceneAudioMute);
  R(() => {
    Howler.mute(t);
  }, [t]);
}, Pr = ({ sceneAudio: t }) => {
  const n = /* @__PURE__ */ $({});
  return B("playAudio", ({ id: e }) => {
    const r = /* @__PURE__ */ t.find((o) => o.id === e);
    if (r && (r.path || r.pathMp3)) {
      if (n.current[e]) {
        n.current[e].play();
        return;
      }
      const o = new ir({ src: [r.path, r.path], loop: r.loop, volume: r.volume || 1 });
      o.play(), n.current[e] = o;
    }
  }), B("stopAudio", ({ id: e }) => {
    const r = n.current[e];
    r && r.stop();
  }), l(kr, {});
}, Cr = () => {
  const [t] = /* @__PURE__ */ j((n) => [n.sceneAudio]);
  return t?.length > 0 ? l(Pr, { sceneAudio: t }) : null;
}, Ht = new _.Euler(), Ve = new _.Quaternion(), Be = new _.Quaternion(), Pe = [], Sr = async (t, n, e) => {
  A({ interactingWith: null }), Ht.fromArray(e), Be.setFromEuler(Ht).normalize();
  const { playerApi: r, halfCapsule: o, sharedCamera: i } = /* @__PURE__ */ V();
  r.partialSleep = true, r.sitting || (Pe[0] = r.positionx, Pe[1] = r.positiony, Pe[2] = r.positionz), r.sitting = true, A({ sitting: true }), i.disableCollider = 1;
  let a;
  const c = new _.Vector3(), d = new _.Vector3(0, 1, 0), s = new _.Vector3();
  s.copy(d), s.multiplyScalar(-o / 1.5), c.set(n[0], n[1], n[2]), c.add(s), A({ autoWalkOn: false, autoWalkDestinations: [], autoWalkForceQuat: false, autoWalkReach: 2 }), r.move = false, r.yAxisCtrl = 0, r.xAxisCtrl = 0, me.runOnceAfterOnePhysicFrame(() => {
    a = $e.to(r, { positionx: c.x, positiony: c.y, positionz: c.z, duration: 0.2, ease: "power2.out", overwrite: true, onUpdate: () => {
      Ve.set(r.quaternionx, r.quaterniony, r.quaternionz, r.quaternionw), Ve.slerp(Be, 0.05), r.quaternionx = Ve.x, r.quaterniony = Ve.y, r.quaternionz = Ve.z, r.quaternionw = Ve.w;
    }, onComplete: () => {
      r.quaternionx = Be.x, r.quaterniony = Be.y, r.quaternionz = Be.z, r.quaternionw = Be.w;
    } }), g(`anim_${O().id}`, { name: "sitting", play: true, reset: true });
  });
  const { microverseId: u } = /* @__PURE__ */ E(), m = await O().user.getIdToken();
  let f = true;
  try {
    const p = await fetch(`/api/${u}/seats/reserve?seat_id=${t}`, { headers: { authorization: `Bearer ${m}` } }), { success: h } = await p.json();
    f = h;
  } catch {
    f = false;
  }
  f || (a && a.reverse(), ce(false));
}, ce = async (t = true) => {
  const { playerApi: n, sharedCamera: e } = /* @__PURE__ */ V();
  if (n.sitting = false, A({ sitting: false }), $e.to(n, { positionx: Pe[0], positiony: Pe[1], positionz: Pe[2], duration: 0.2, onComplete: () => {
    n.partialSleep = false, e.disableCollider = 0;
  } }), g(`anim_${O().id}`, { name: "idle", play: true }), t) {
    const { microverseId: r } = /* @__PURE__ */ E(), o = await O().user.getIdToken();
    fetch(`/api/${r}/seats/leave`, { headers: { authorization: `Bearer ${o}` } });
  }
}, Re = new _.Vector3(), Gt = new _.Vector3(), Mr = [], Qt = new _.Quaternion(), _r = new _.Vector3(1, 0, 0), Ir = Math.PI / 2;
Qt.setFromAxisAngle(_r, Ir);
function Ar({ debug: t = true }) {
  const n = /* @__PURE__ */ Me("isMobile"), e = /* @__PURE__ */ $(), r = /* @__PURE__ */ $(), o = /* @__PURE__ */ $(false), i = /* @__PURE__ */ $(false), a = /* @__PURE__ */ $(), c = /* @__PURE__ */ Ee((p) => p.gl), d = /* @__PURE__ */ $(), s = /* @__PURE__ */ $();
  Fn((p) => p.paintData);
  const u = /* @__PURE__ */ he(() => {
    const { playerApi: p } = /* @__PURE__ */ V();
    A({ autoWalkOn: false, autoWalkDestinations: [], autoWalkForceQuat: false, autoWalkReach: 2 }), p.move = false, p.yAxisCtrl = 0, p.xAxisCtrl = 0, i.current = false, clearTimeout(a.current);
    const { positionx: h, positiony: y, positionz: v, sitting: b } = p;
    let P;
    b ? P = Pe.slice(0) : P = [h, y, v], A({ lastKnownValidLocation: P });
  }, []);
  B("trigger_gamepad", (p) => {
    o.current = p, A({ mouseDown: p });
  });
  const m = () => {
    o.current = false, A({ mouseDown: false }), clearTimeout(e.current);
    const { aimMode: p } = /* @__PURE__ */ z();
    r.current && !p && u(), p && (g("stopAudio", { id: ge.paint }), g("playAudio", { id: ge.stopPaint })), r.current = false;
  };
  B("exitPointerLock", m), R(() => {
    const p = () => {
      const v = d.current, b = s.current, { aimMode: P } = /* @__PURE__ */ z();
      if (P)
        return;
      const { sharedFileEditor: T, sharedFileFocused: k } = /* @__PURE__ */ E();
      if (T || k) {
        v && (v.visible = false), b && (b.visible = false);
        return;
      }
      if (v && (v.visible = !n), b && (b.visible = !n), !o.current)
        return;
      const { playerApi: x } = /* @__PURE__ */ V();
      if (!x)
        return;
      clearTimeout(a.current), i.current = false;
      const { sharedPointer: C } = /* @__PURE__ */ V();
      C && (Re.set(C[3], C[4], C[5]), Gt.set(Re.x - x.positionx, Re.y - x.positiony, Re.z - x.positionz), !(Gt.length() <= 1) && (t && v && b && (v.visible = true, b.visible = true, b.position.copy(Re), b.quaternion.set(x.quaternionx, x.quaterniony, x.quaternionz, x.quaternionw), b.quaternion.multiply(Qt), b.updateMatrix(), b.updateMatrixWorld(), $e.fromTo(b.scale, { x: 0.2, y: 0.2, z: 0.2 }, { x: 1, y: 1, z: 1, duration: 0.6, ease: "power2.out", overwrite: true, onUpdate: () => {
        b.updateMatrix(), b.updateMatrixWorld();
      }, onComplete: () => {
        b.visible = false;
      } }), $e.fromTo(b.material, { opacity: 1 }, { opacity: 0, duration: 0.6, ease: "power1.out", overwrite: true }), $e.to(v.scale, { keyframes: { x: [1, 2.5, 1], y: [0.1, 0.2, 0.1], z: [1, 2.5, 1] }, duration: 0.9, ease: "power2.out", overwrite: true, onUpdate: () => {
        v && (v.updateMatrix(), v.updateMatrixWorld());
      } }), $e.to(v.material, { keyframes: { opacity: [0.6, 0, 0, 0.6] }, duration: 0.9, ease: "power1.out", overwrite: true })), A({ autoWalkForceQuat: true, autoWalkOn: true, autoWalkReach: 0.2, autoWalkDestinations: [{ dest: Re.toArray(Mr) }] }), a.current = setTimeout(() => {
        i.current = true;
      }, 1e3)));
    }, h = /* @__PURE__ */ setInterval(p, 100), y = () => {
      const { isScreenshot: v, editorMode: b, sharedFileEditor: P, sharedFileFocused: T, isInteractingWithNode: k } = /* @__PURE__ */ E();
      if (b || v || P || T || k)
        return;
      const { playerApi: x } = /* @__PURE__ */ V(), { aimMode: C } = /* @__PURE__ */ z();
      C && g("playAudio", { id: ge.paint }), x.sitting && ce(), e.current = setTimeout(() => {
        r.current = true;
      }, 200), o.current = true, A({ mouseDown: true }), n && setTimeout(() => {
        o.current || (o.current = true, p(), o.current = false);
      }, 50);
    };
    return c.domElement.addEventListener("pointerdown", y), c.domElement.addEventListener("pointerup", m), () => {
      clearInterval(h), c.domElement.removeEventListener("pointerdown", y), c.domElement.removeEventListener("pointerup", m);
    };
  }, [c]);
  const f = /* @__PURE__ */ Qe((p) => p.playerApi);
  return B("readPhysicState", ({ state: p, delta: h, isXR: y }) => {
    const v = d.current, { aimMode: b } = /* @__PURE__ */ z();
    if (t && v) {
      const { sharedPointer: P } = /* @__PURE__ */ V();
      if (!P)
        return;
      v.position.set(P[3], P[4], P[5]);
      const T = 0;
      if (b && o.current) {
        g("brush_position", { id: T, playerId: O().id, position: [P[3], P[4], P[5]] });
        const k = Math.floor(P[3] * 1e3) / 1e3, x = Math.floor(P[4] * 1e3) / 1e3, C = Math.floor(P[5] * 1e3) / 1e3;
        g("paint_position", `${k},${x},${C}`);
      }
      v.quaternion.set(f.quaternionx, f.quaterniony, f.quaternionz, f.quaternionw), v.updateMatrix(), v.updateMatrixWorld();
    }
    !b && i.current && f.deltaPosLocalBetweenRafz < 0.4 && u();
  }), t ? M(H, { children: [M("mesh", { ref: d, "rotation-x": 0, scale: [1, 0.1, 1], visible: false, children: [l("sphereGeometry", { args: [0.1, 16] }), l("meshBasicMaterial", { color: "white", transparent: true, opacity: 0, blending: _.NormalBlending })] }), M("mesh", { ref: s, renderOrder: -99999, "rotation-x": -Math.PI / 2, visible: false, children: [l("torusGeometry", { args: [0.5, 0.035, 16, 32] }), l("meshBasicMaterial", { color: "white", transparent: true, opacity: 0, depthTest: false, depthWrite: false, blending: _.NormalBlending })] })] }) : null;
}
const Tr = { drag: { filterTaps: true, pointer: { touch: false } }, pinch: { scaleBounds: { min: 0.1, max: 10 }, pointer: { touch: false } } }, Er = () => {
  const t = /* @__PURE__ */ j((r) => r.editorMode), [n, e] = /* @__PURE__ */ be((r) => [r.dom, r.aimMode]);
  return sr({ onDrag: ({ delta: r }) => {
    const { focusingInput: o } = /* @__PURE__ */ E();
    if (o)
      return;
    const { aimMode: i, dragSensitivity: a } = /* @__PURE__ */ z();
    if (i)
      return;
    const { sharedCamera: c } = /* @__PURE__ */ V();
    if (!c)
      return;
    const d = window.innerWidth / 2, s = window.innerHeight, u = 1e-3;
    c.dragDeltax = -r[0] / (d * u / a), c.dragDeltay = r[1] / (s * u / a), c.resetCamera = false, te({ isDragging: true });
  }, onWheel: ({ delta: r }) => {
    const { sharedCamera: o } = /* @__PURE__ */ V();
    o.offsetAdjuster += r[1] / 100, o.offsetAdjuster = Math.min(Math.max(o.offsetAdjuster, _n), In);
  }, onPointerDown: () => {
    te({ isDragging: true });
  }, onPointerUp: () => {
    const { lockRotation: r, aimMode: o } = /* @__PURE__ */ z();
    r && gt();
  } }, { target: n, ...Tr, enabled: !t && !e }), null;
}, oe = () => {
  const { isIdle: t } = /* @__PURE__ */ E(), { aimMode: n } = /* @__PURE__ */ z();
  A({ isIdle: false }), g("userAction"), t && !n && g("resetOffsetCamera");
}, et = { current: null };
function $r(t) {
  const n = (e) => E().focusingInput && e.key !== "Enter" && e.key !== "Escape";
  R(() => {
    const e = {};
    for (let d = 0; d < t.length; d++) {
      const { keys: s, fn: u, up: m = true, priority: f = 0 } = t[d];
      s && s.forEach((p) => {
        e[p] = e[p] ? [...e[p], { fn: u, priority: f, up: m }] : [{ fn: u, priority: f, up: m }], e[p].sort((h, y) => h.priority - y.priority), e[p].key = p, e[p].pressed = false;
      });
    }
    const r = ({ code: d, key: s, metaKey: u, shiftKey: m, ctrlKey: f }) => {
      const p = e[d] || e[s];
      if (!p || n(p) || et.current === p.key)
        return;
      et.current = p.key;
      const { pressed: h } = p, y = h;
      p.pressed = true;
      for (let v = 0; v < p.length && !((p[v].up || !h) && p[v].fn(true, { wasPressed: y, shiftKey: m, metaKey: u, ctrlKey: f, keyMap: e, cachePressedKey: et }) === false); v++)
        ;
    }, o = ({ code: d, key: s }) => {
      const u = e[d] || e[s];
      if (!u || n(u))
        return;
      const { autoWalkOn: m } = /* @__PURE__ */ E();
      if (!m) {
        et.current = null, u.pressed = false;
        for (let f = 0; f < u.length && !(u[f].up && u[f].fn(false, {}) === false); f++)
          ;
      }
    }, i = () => {
      for (const d in e)
        if (e[d].pressed) {
          e[d].pressed = false;
          for (let s = 0; s < e[d].length && !(e[d][s].up && e[d][s].fn(false, { autoPress: true }) === false); s++)
            ;
        }
    }, a = () => i(), c = /* @__PURE__ */ We("resetcontrols", a);
    return window.addEventListener("keydown", r), window.addEventListener("keyup", o), window.addEventListener("blur", i), window.addEventListener("contextmenu", i), () => {
      $n("resetcontrols", a, { context: c }), window.removeEventListener("keydown", r), window.removeEventListener("keyup", o), window.removeEventListener("blur", i), window.removeEventListener("contextmenu", i);
    };
  }, [t]);
}
function Dr({ keyboardConf: t = [] }) {
  return R(() => {
    const n = (r) => {
      r && r.target && (["TEXTAREA", "INPUT"].includes(r.target.tagName) || r.target.getAttribute("contenteditable")) ? A({ focusingInput: true }) : A({ focusingInput: false });
    }, e = () => {
      A({ focusingInput: false });
    };
    return document.addEventListener("focusin", n), document.addEventListener("focusout", e), () => {
      A({ focusingInput: false }), document.removeEventListener("focusin", n), document.removeEventListener("focusout", e);
    };
  }, []), $r([{ keys: ["KeyE"], fn: (n) => {
    const { isScreenshot: e, editorMode: r } = /* @__PURE__ */ E();
    r || e || (oe(), n && g("interact"));
  }, up: false }, { keys: ["ArrowDown", "KeyS", "KeyK", "Numpad5", "Numpad2"], fn: (n, { autoPress: e }) => {
    oe(), n && g("downCtrl");
    const { playerApi: r } = /* @__PURE__ */ V();
    r.sitting && !e && ce();
    const { birdView: o } = /* @__PURE__ */ z(), { controls: i, isCustomising: a, disableControls: c } = /* @__PURE__ */ E();
    if (!(c || o) && !a) {
      const { forward: d, left: s, right: u } = i;
      A({ moveAlongZ: d || n, autoWalkOn: false }), r && (r.move = u || d || n || s ? 1 : 0, r.yAxisCtrl = n ? -1 : d ? 1 : 0), A((m) => ({ controls: { ...m.controls, backward: n } }));
    }
  } }, { keys: ["ArrowUp", "KeyW", "KeyI", "Numpad8"], fn: (n, { autoPress: e }) => {
    oe(), n && g("upCtrl");
    const { playerApi: r } = /* @__PURE__ */ V();
    r.sitting && !e && ce();
    const { birdView: o } = /* @__PURE__ */ z(), { controls: i, isCustomising: a, disableControls: c } = /* @__PURE__ */ E();
    if (!(c || o) && !a) {
      const { left: d, right: s, backward: u } = i;
      A({ moveAlongZ: n || u, autoWalkOn: false }), r && (r.move = s || n || u || d ? 1 : 0, r.yAxisCtrl = u ? -1 : n ? 1 : 0), A((m) => ({ controls: { ...m.controls, forward: n } }));
    }
  } }, { keys: ["KeyA", "KeyJ", "ArrowLeft", "Numpad4"], fn: (n, { autoPress: e }) => {
    oe(), n && g("leftCtrl");
    const { playerApi: r } = /* @__PURE__ */ V();
    r.sitting && !e && ce();
    const { birdView: o } = /* @__PURE__ */ z(), { controls: i, isCustomising: a, disableControls: c } = /* @__PURE__ */ E();
    if (!(c || o)) {
      if (!a) {
        const { forward: d, right: s, backward: u } = i;
        A({ moveAlongZ: d || u, autoWalkOn: false }), r && (r.move = s || d || u || n ? 1 : 0, r.xAxisCtrl = s ? 1 : n ? -1 : 0), A((m) => ({ controls: { ...m.controls, left: n } }));
      }
      return true;
    }
  } }, { keys: ["KeyD", "KeyL", "ArrowRight", "Numpad6"], fn: (n, { autoPress: e }) => {
    oe(), n && g("rightCtrl");
    const { playerApi: r } = /* @__PURE__ */ V();
    r.sitting && !e && ce();
    const { birdView: o } = /* @__PURE__ */ z(), { controls: i, isCustomising: a, disableControls: c } = /* @__PURE__ */ E();
    if (!(c || o) && !a) {
      const { forward: d, left: s, backward: u } = i;
      A({ moveAlongZ: d || u, autoWalkOn: false }), r && (r.move = n || d || u || s ? 1 : 0, r.xAxisCtrl = n ? 1 : s ? -1 : 0), A((m) => ({ controls: { ...m.controls, right: n } }));
    }
  } }, { keys: ["Space"], fn: (n, { wasPressed: e, autoPress: r }) => {
    oe();
    const { playerApi: o } = /* @__PURE__ */ V();
    o.sitting && !r && ce();
    const { disableControls: i } = /* @__PURE__ */ E();
    i || e || (n ? g("ctrl_jump") : g("ctrl_stopJump"));
  } }, { keys: ["Escape"], fn: (n, { autoPress: e }) => {
    A({ playCinematicId: null });
    const { playerApi: r } = /* @__PURE__ */ V();
    if (r.sitting && !e && ce(), E().isScreenshot) {
      g("enterCtrl");
      return;
    }
    g("escapeCtrl"), g("cancelUI");
  }, up: false }, { keys: ["u", "U"], fn: () => {
    if (E().focusingInput)
      return;
    const n = E().disableUI;
    Fe({ hideUi: !n }), A({ disableUI: !n });
  }, up: false }, { keys: ["1"], fn: () => g("ctrl_thankYou"), up: false }, { keys: ["2"], fn: () => g("ctrl_meditateyoyo"), up: false }, { keys: ["3"], fn: () => g("ctrl_dance"), up: false }, { keys: ["4"], fn: () => g("ctrl_bow"), up: false }, { keys: ["5"], fn: () => {
    document.URL.includes(".sougen.co") && !W.isAdmin() || g("playcinematic_curve_planetarium", { cancelable: true });
  }, up: false }, { keys: ["6"], fn: () => {
    document.URL.includes(".sougen.co") && !W.isAdmin() || g("playcinematic_curve_onboarding", { cancelable: true });
  }, up: false }, { keys: ["7"], fn: () => {
    document.URL.includes(".sougen.co") && !W.isAdmin() || g("playcinematic_curve_parkour", { cancelable: true });
  }, up: false }, { keys: ["8"], fn: () => {
    document.URL.includes(".sougen.co") && !W.isAdmin() || g("playcinematic_curve_entry", { cancelable: true });
  }, up: false }, { keys: ["n", "N"], fn: () => {
    const { settings: n } = /* @__PURE__ */ O();
    n.privacy.showNames = !n.privacy.showNames, Fe({ settings: n });
  }, up: false }, { keys: ["t", "T"], fn: () => {
    te({ preventReset: !z().preventReset });
  }, up: false }, { keys: ["f", "F"], fn: (n) => {
    g("quick-emoji", { up: n });
  } }, { keys: ["."], fn: () => {
    document.URL.includes(".sougen.co") && !W.isAdmin() || te({ editor: !z().editor });
  }, up: false }, { keys: ["v", "V"], fn: (n, { ctrlKey: e, metaKey: r, keyMap: o }) => {
    const { editorMode: i, uiSettings: a } = /* @__PURE__ */ E();
    i || a.disableCameraChange || (z().setNextCameraMode(), g("userAction"));
  }, up: false }, ...t]), null;
}
let Pt = false;
function Fr() {
  const [t, n] = /* @__PURE__ */ N(false), e = /* @__PURE__ */ $(null), r = /* @__PURE__ */ $({ buttons: [], axes: [] }), o = (s) => {
    console.log("Contrôleur n°%d connecté : %s. %d boutons, %d axes.", s.gamepad.index, s.gamepad.id, s.gamepad.buttons.length, s.gamepad.axes.length), n(true), e.current = s.gamepad, r.current.buttons = Array(s.gamepad.buttons.length), r.current.axes = Array(s.gamepad.axes.length);
  }, i = (s) => {
    console.log("Contrôleur n°%d déconnecté : %s", s.gamepad.index, s.gamepad.id), n(false);
    const { playerApi: u } = /* @__PURE__ */ V();
    u.move = false, u.forceFactor = 0, u.turnFactor = 0, u.xAxisCtrl = 0, u.yAxisCtrl = 0, A({ moveAlongZ: 0 }), e.current = null;
  }, a = (s, u) => {
    const { playerApi: m } = /* @__PURE__ */ V(), { disableControls: f, autoWalkOn: p } = /* @__PURE__ */ E(), { dialogMode: h, birdView: y } = /* @__PURE__ */ z();
    if (r.current.buttons[s] = u, !p) {
      if (oe(), s === 0 && !f && !y && (u ? m.driving || g("ctrl_jump") : m.driving || g("ctrl_stopJump")), s === 1 && !f && !y && (m.driving ? (m.yAxisCtrl = u ? 1 : 0, m.xAxisCtrl = r.current.axes[0]) : (ct().actionFocused(), h ? g("enterCtrl") : g("interact"))), s === 7 && !f && !y && (u ? m.driving && (g("ctrl_jump"), m.driftPressed = true) : m.driving && (g("ctrl_stopJump"), m.driftPressed = false)), u && s === 12 && g("ctrl_meditateyoyo"), u && s === 13 && g("ctrl_thankYou"), u && s === 14 && ct().focusNext(), u && s === 15 && ct().focusPrev(), u && s === 8) {
        if (E().uiSettings?.disableCameraChange)
          return;
        z().setNextCameraMode(), g("changedCameraView");
        const v = z().lockRotation, { workerApiRef: b } = /* @__PURE__ */ V();
        b.current.updatePhysicProp({ lockRotation: v });
      }
      (s === 6 || s === 7) && !f && !y && g("trigger_gamepad", u);
    }
  }, c = (s, u) => {
    const { playerApi: m } = /* @__PURE__ */ V(), { disableControls: f, autoWalkOn: p } = /* @__PURE__ */ E(), { birdView: h } = /* @__PURE__ */ z();
    if (s === 0 && r.current.axes[s] > -0.8 && u <= -0.8 ? g("leftCtrl") : s === 0 && r.current.axes[s] < 0.8 && u >= 0.8 ? g("rightCtrl") : s === 1 && r.current.axes[s] > -0.8 && u < -0.8 ? g("upCtrl") : s === 1 && r.current.axes[s] < 0.8 && u >= 0.8 && g("downCtrl"), r.current.axes[s] = u, p)
      return;
    const y = m.driving ? e.current[0].buttons[1].pressed : r.current.axes[1] > 0.1 || r.current.axes[1] < -0.1, v = f || h ? false : y || r.current.axes[0] > 0.1 || r.current.axes[0] < -0.1;
    A({ moveAlongZ: h || f ? 0 : y }), v && oe(), m.move = v, m.xAxisCtrl = r.current.axes[0], m.yAxisCtrl = -r.current.axes[1];
  }, d = (s, u) => {
    r.current.axes[s] = u;
    const m = r.current.axes, f = m[2] > 0.1 || m[2] < -0.1 || m[3] > 0.1 || m[3] < -0.1;
    if (!Pt && f ? te({ isDragging: true }) : !f && Pt && gt(), f) {
      oe();
      const { dragSensitivity: p, aimMode: h } = /* @__PURE__ */ z(), { sharedCamera: y } = /* @__PURE__ */ V();
      y.preventDrag = 0;
      const v = h ? -1 : 1;
      y.dragDeltax = r.current.axes[2] * 6 * p * p * v, y.dragDeltay = r.current.axes[3] * 4 * p * p, y.resetCamera = false;
    }
    Pt = f;
  };
  return R(() => (window.addEventListener("gamepadconnected", o), window.addEventListener("gamepaddisconnected", i), () => {
    window.removeEventListener("gamepadconnected", o), window.removeEventListener("gamepaddisconnected", i);
  })), X(() => {
    if (t && (e.current = navigator.getGamepads ? navigator.getGamepads() : navigator.webkitGetGamepads ? navigator.webkitGetGamepads : [], !(!e.current || e.current.length <= 0 || !e.current[0]))) {
      for (let s = 0; s < e.current[0].buttons.length; s++)
        e.current[0].buttons[s].pressed !== r.current.buttons[s] && a(s, e.current[0].buttons[s].pressed);
      for (let s = 0; s < 2; s++)
        e.current[0].axes[s] !== r.current.axes[s] && c(s, e.current[0].axes[s]);
      for (let s = 2; s < 4; s++)
        d(s, e.current[0].axes[s]);
    }
  }, W.renderPriority.default), null;
}
const Ur = ({ keyboardConf: t }) => {
  const n = /* @__PURE__ */ Me("isMobile"), e = /* @__PURE__ */ Me("isDesktop");
  return R(() => {
    if (typeof document > "u")
      return;
    const r = () => {
      A({ pageInteracted: true });
    };
    return document.addEventListener("mousedown", r), document.addEventListener("touchstart", r), () => {
      document.removeEventListener("mousedown", r), document.removeEventListener("touchstart", r);
    };
  }, []), M(H, { children: [!n && l(Dr, { keyboardConf: t }), e ? l(Er, {}) : null] });
}, Vr = () => {
  const t = /* @__PURE__ */ be((n) => n.aimMode);
  return M(H, { children: [l(Fr, {}), l(Ar, {}), t ? l(vr, {}) : null] });
}, Br = 2500, Jt = ["run", "walk", "forward_walk", "forward_run", "right_walk", "right_run", "forward_right_walk", "forward_right_run", "backward_walk", "backward_run", "backward_right_walk", "backward_right_run", "right_walk_mirror", "right_run_mirror", "forward_right_walk_mirror", "forward_right_run_mirror", "backward_right_walk_mirror", "backward_right_run_mirror"], Rr = (t, n) => {
  !t.activAnimations.jump && !t.activAnimations.jump_mirror && (g(`anim_${n}`, { name: `jump${Math.random() < 0.5 ? "_mirror" : ""}`, blendDuration: 0.1, reset: true, timeScale: 1 }), g(`anim_pet_${n}`, { name: "Flying", blendDuration: 0.1, timeScale: 1, startAt: 0.5 }));
}, Nr = (t, n) => {
  !t.activAnimations.glide && !t.activAnimations.glide_mirror && (g(`anim_${n}`, { name: `glide${Math.random() < 0.5 ? "_mirror" : ""}`, blendDuration: 0.25, timeScale: 1 }), g(`anim_pet_${n}`, { name: "Idle_5", blendDuration: 0 }));
}, Or = (t, n) => {
  !t.activAnimations.slide && !t.activAnimations.slide_mirror && (g(`anim_${n}`, { name: "slide", blendDuration: 0.3, timeScale: 1 }), g(`anim_pet_${n}`, { name: "Sliding" }));
}, zr = ({ id: t, playerApi: n, controls: e, normalizedSpeedRatio: r, isWalking: o }) => {
  const i = n.localVelocityx > 0.5, a = n.localVelocityx < -0.5, c = n.localVelocityz > 0.5, d = n.localVelocityz < -0.5, s = r > 2 ? "run" : "walk";
  let u = null;
  c ? i ? u = `forward_right_${s}_mirror` : a ? u = `forward_right_${s}` : u = `forward_${s}` : d ? i ? u = `backward_right_${s}_mirror` : a ? u = `backward_right_${s}` : u = "backward_run" : i ? u = `right_${s}_mirror` : a && (u = `right_${s}`);
  const m = /* @__PURE__ */ Math.max(Math.min(1.1 * r, 8), -8);
  g(`anim_${t}`, { name: u, weight: 1, blendDuration: 0.2, timeScale: m });
}, Lr = (t, n) => n.some((e) => t.activAnimations[e]), Wr = ({ id: t, player: n, playerApi: e, normalizedSpeedRatio: r }) => {
  const o = Math.sign(e.localVelocityz) || -1;
  Math.abs(e.localVelocityz) > 0.5 && Math.abs(e.localVelocityx) < 0.5 && g(`anim_${t}`, { name: o === 1 ? "forward_walk" : "backward_walk", reset: !Lr(n, Jt), syncWith: n.activAnimations.run ? "run" : void 0, blendDuration: 0.3, timeScale: Math.max(Math.min(r * (Math.sign(e.localVelocityz) || -1), 5), -5) });
}, jr = ({ id: t, playerApi: n, normalizedSpeedRatio: e, syncWith: r }) => {
  const o = Math.sign(n.localVelocityz) || -1;
  g(`anim_${t}`, { name: o === 1 ? "forward_run" : "backward_run", syncWith: r, blendDuration: 0.2, timeScale: Math.max(Math.min(e * (Math.sign(n.localVelocityz + n.localVelocityx) || -1), 5), -5) });
}, Xt = (t, n) => {
  Jt.forEach((e) => {
    t.activAnimations[e] && g(`anim_${n}`, { name: e, play: false, blendDuration: 0.2 });
  });
}, qr = (t, n, e) => {
  e.right && !t.activAnimations.turnright ? g(`anim_${n}`, { name: "turnright", blendDuration: 0.25, timeScale: 1 }) : e.left && !t.activAdditiveAnimations.turnright_mirror && g(`anim_${n}`, { name: "turnright_mirror", blendDuration: 0.25, timeScale: 1 });
}, Kt = (t, n, e) => {
  let r = setTimeout(() => {
  });
  const o = /* @__PURE__ */ Qe((d) => d.forceCapacity), [i, a] = /* @__PURE__ */ j((d) => [d.startWalkFrom, d.startRunFrom]), c = o * 12;
  X(function() {
    if (!e || e.indexInArray === void 0)
      return;
    const { sliding: s, canJump: u, jumping: m, flying: f, falling: p, driving: h } = e, { controls: y, isIdle: v, isAfk: b, isCustomising: P, interactingWith: T, isScreenshot: k, isAnimPaused: x, disableIdleCamera: C } = /* @__PURE__ */ E(), { aimMode: D } = /* @__PURE__ */ z();
    if (e.sleep || e.partialSleep || k || x || !n)
      return;
    const { player: w } = n.userData;
    if (m && Rr(w, t), f && Nr(w, t), (s || h) && Or(w, t), u) {
      if (!s && !m && !p && !f && !h) {
        const q = Math.abs(e.deltaPosLocalBetweenRafx) + Math.abs(e.deltaPosLocalBetweenRafy) + Math.abs(e.deltaPosLocalBetweenRafz), le = 1 / (c / q) / (w.height * 0.75);
        Math.abs(q) >= i ? D ? zr({ id: t, playerApi: e, controls: y, normalizedSpeedRatio: le }) : q < a ? (Wr({ id: t, player: w, playerApi: e, normalizedSpeedRatio: le }), g(`anim_pet_${t}`, { name: "Idle_1" })) : (jr({ id: t, playerApi: e, normalizedSpeedRatio: le, syncWith: w.activAnimations.walk ? "walk" : void 0 }), g(`anim_pet_${t}`, { name: "Idle_1" })) : (Xt(w, t), w.playingEmote || (!v && !b && !P && (y.right || y.left) && (D || qr(w, t, y)), !b && !v ? (!w.activAnimations.default && w.playingEmote, clearTimeout(r), A({ isIdle: true }), r = window.setTimeout(() => {
          const { isIdle: Q, isCustomising: ue, interactingWith: fe } = /* @__PURE__ */ E();
          Q && !w.playingEmote && !w.activAnimations.idle && !w.activAnimations.idle_mirror && !ue && !fe && !e.partialSleep && (g(`anim_${t}`, { name: `idle${Math.random() < 0.5 ? "_mirror" : ""}`, play: true, blendDuration: 1, timeScale: 1 }), C || g("idleCamera", {}));
        }, Br)) : T || b && !w.activAnimations.kneelidle && g(`anim_${t}`, { name: "kneelidle", play: true, blendDuration: 1, timeScale: 1 })));
      } else
        (w.activAnimations.glide || w.activAnimations.glide_mirror) && g(`anim_${t}`, { name: `idle${Math.random() < 0.5 ? "_mirror" : ""}`, blendDuration: 0.4, timeScale: 1 });
    } else
      Xt(w, t), !w.activAnimations.jump && !w.activAnimations.jump_mirror && (e.falling = true);
    (Object.keys(w.activAnimations).length === 0 || u && (w.activAnimations.jump || w.activAnimations.jump_mirror)) && g(`anim_${t}`, { name: `idle${Math.random() < 0.5 ? "_mirror" : ""}`, blendDuration: 0.4, timeScale: 1 });
    const S = w.fly;
    w.fly = f && w.perks.collection === "ancient", w.fly !== S && g(`updatePeerAttr_${t}`, { fly: true });
    const U = w.driving;
    w.driving = h, w.driving !== U && g(`updatePeerAttr_${t}`, { drive: true });
    const L = w.slide;
    w.slide = s || h, w.slide !== L && g(`updatePeerAttr_${t}`, { slide: true });
  }, 2);
}, Hr = ({ playerMesh: t }) => {
  const n = /* @__PURE__ */ be((e) => e.firstPerson);
  return R(() => {
    if (!t || !t.api)
      return;
    const e = /* @__PURE__ */ t.api.getParent();
    e.current && e.current.setIsActive(t.userData.id, !n);
  }, [n, t]), null;
}, Yt = new _.Vector3(), Ne = new _.Vector3(), Oe = new _.Vector3(), Gr = new _.Vector3(), ze = new _.Vector3(), Zt = new _.Vector3(), qe = new _.Euler(), en = new _.Quaternion(), Qr = new _.Vector3(0, 0, 1), de = new _.Object3D(), Jr = (t, n, e) => {
  const { autoWalkOn: r, autoWalkDestinations: o, autoWalkReach: i = 2, autoWalkForceQuat: a } = /* @__PURE__ */ E();
  if (r && o[0]) {
    Ne.copy(t), Oe.fromArray(o[0].dest), ze.set(e.attractorx, e.attractory, e.attractorz), Ne.addScaledVector(ze, -Ne.dot(ze)), Oe.addScaledVector(ze, -Oe.dot(ze)), Zt.subVectors(Oe, Ne).normalize(), Yt.copy(Qr).applyQuaternion(n), en.setFromUnitVectors(Yt, Zt), qe.setFromQuaternion(en, "YXZ"), qe.y > 0.1 ? e.xAxisCtrl = -1 : qe.y < -0.1 ? e.xAxisCtrl = 1 : e.xAxisCtrl = 0, Gr.fromArray(o[0].dest);
    const c = /* @__PURE__ */ Ne.distanceTo(Oe);
    if (a && (de.position.copy(Ne), de.up.copy(ze), de.updateMatrix(), de.updateMatrixWorld(), de.lookAt(Oe), e.quaternionx = de.quaternion.x, e.quaterniony = de.quaternion.y, e.quaternionz = de.quaternion.z, e.quaternionw = de.quaternion.w), c > i)
      e.autoWalk = true, e.move = true, qe.y > 1 ? e.yAxisCtrl = 0 : e.yAxisCtrl = 1 * (1 - qe.y);
    else {
      e.autoWalk = false, e.move = false, e.yAxisCtrl = 0, o[0].onReach && o[0].onReach(), o.shift();
      const d = !!o.length;
      A({ autoWalkForceQuat: d ? a : false, autoWalkDestinations: o, autoWalkOn: d });
    }
  }
}, Xr = (t, n) => Math.ceil(n.position.distanceTo(t.position) * 10) / 10, Kr = (t) => {
  const { playersMeshes: n, closestPlayers: e } = /* @__PURE__ */ re();
  if (t) {
    e.length = 0;
    for (const r in n) {
      const o = n[r], { player: i, id: a } = o.userData;
      if (i.isNpc || i.playerId === "tempId" || t.uuid === o.uuid || o.position.y === -9999)
        continue;
      const c = /* @__PURE__ */ Xr(t, o);
      i.prevDistToPlayer = i.distToPlayer, i.distToPlayer = c, i.meshId = a, e.push(i);
    }
    e.sort((r, o) => r.distToPlayer - o.distToPlayer);
    for (let r = 0; r < e.length; r++)
      e[r].closestRank = r + 1;
    return e;
  }
}, Yr = (t) => {
  let n = 0;
  X(function(r, o) {
    n += o, !(n < 0.1) && (n = 0, Kr(t));
  }, W.renderPriority.updateAllPositions + 0.1);
}, Zr = (t) => (j((n) => n.moveAlongZ, (n, e) => {
  if (!n && e) {
    const { lockRotation: r, preventReset: o, aimMode: i } = /* @__PURE__ */ z();
    if (!r || o)
      return true;
    const { sharedCamera: a } = /* @__PURE__ */ V();
    i && t || (a.resetCamera = true), te({ isDragging: false });
  }
  return true;
}), null), eo = ({ dom: t, setRef: n }) => {
  const [e, r] = /* @__PURE__ */ be((o) => [o.disableOrbitDrag, o.showHelpers]);
  return M(H, { children: [l(Un, { ref: n, domElement: t.current, makeDefault: true, onStart: () => {
    te({ active: true });
  }, enablePan: !e, enableRotate: !e, onEnd: () => {
    te({ active: false });
  } }), l(Vn, { position: [100, 100, 100], makeDefault: true, fov: 50, far: 3500, matrixAutoUpdate: true })] });
}, to = () => {
  const t = /* @__PURE__ */ dt((h) => h.currentPlayer), [n, e] = /* @__PURE__ */ N(), [r, o, i, a, c, d, s, u, m] = /* @__PURE__ */ be((h) => [h.orbitCtrl, h.focusPlayer, h.focusCameraman, h.refCamera, h.editor, h.control, h.dom, h.disableOrbitDrag, h.showHelpers]), f = /* @__PURE__ */ $(), p = /* @__PURE__ */ Ee((h) => h.scene);
  return R(() => {
    let h;
    if (a && a.current && (f.current = h = new tr(a.current)), h)
      return h.traverse((y) => y.raycast = () => null), p.add(h), () => {
        f.current = void 0, p.remove(h), h?.dispose();
      };
  }, [p, a]), R(() => {
    f.current && (f.current.noRenderInPreview = true), d.current = n, te({ orbitCtrlReady: r && n, control: d });
  }, [r, n]), X((h, y) => {
    d.current && (o && d.current.target.damp(t.position, 4, y), i && d.current.target.damp(a.current.position, 4, y)), f.current && (f.current.visible = m), m && f.current && (f.current.matrix.copy(a.current.matrix), f.current.matrixWorld.copy(a.current.matrixWorld));
  }, 9), c || r ? l(eo, { dom: s, setRef: e }) : null;
}, no = () => {
  const [t, n, e] = /* @__PURE__ */ Qe((d) => [d.totalEssentialReady, d.physicStarted, d.playerApiReady]), [r, o, i, a, c] = /* @__PURE__ */ Et((d) => [d.totalEssentials, d.startPositionSet, d.waitForAllLoad, d.step0Complete, d.essentialsReady]);
  return R(() => {
    Je({ countPhysicElement: true });
  }, []), R(() => {
    !a || !e || n || !o || (console.log(`🔄 ${Math.round(parseFloat(t) / parseFloat(r) * 100)}% essential loaded`), t >= r && Je({ essentialsReady: true }));
  }, [e, t, r, o, n, a]), R(() => {
    if (n || !c)
      return;
    g("register-session-log", { type: "physicStarted" });
    const { editorMode: d } = /* @__PURE__ */ E();
    me.paused = d, d || g(`anim_holo_tp_${O().id}`, { teleportingOut: false, reset: true }), setTimeout(() => {
      i ? Je({ fetchingText: "fetching-data", loadingStep: 1 }) : Je({ active: false, forceLoader: false, fetchingText: "fetching-data", loadingStep: 1 });
    }), V().attchProxyEvents(), Tt({ physicStarted: true }), g("physicready"), me.pauseReadPhysic = false, g("resetOffsetCamera");
  }, [n, c]), l(to, {});
}, ro = ({ playerMesh: t }) => {
  const n = /* @__PURE__ */ Me("isDesktop"), e = /* @__PURE__ */ Qe((r) => r.physicIsInit);
  return Zr(n), M(H, { children: [l(no, {}), e ? l(An, { isDesktop: n, withCinematic: true, targetRef: t }) : null] });
}, Ct = new _.Vector3(), St = new _.Vector3(), Ce = new _.Vector3(), oo = (t, n) => {
  const e = /* @__PURE__ */ $(), r = () => setTimeout(() => {
    n.jumping = 0, n.falling = 1;
  }, 400);
  R(() => () => {
    clearTimeout(e.current);
  }, []), B("ctrl_jump", () => {
    const { jumpVelocity: o } = /* @__PURE__ */ V(), { flying: i, jumping: a, canJump: c, canFly: d, velocity: s, falling: u, orbital: m } = n;
    n.driftPressed = true;
    const { jumpEnabled: f, flyEnabled: p } = /* @__PURE__ */ E();
    if (f && c && !a && !i) {
      n.jumping = 1, n.sliding = 0, g("playAudio", { id: ge.jump }), n.driving ? (St.set(0, o, 0).applyQuaternion(n.entity.quaternion), Ce.set(n.externalVelocityx, n.externalVelocityy, n.externalVelocityz), Ct.copy(St).normalize(), Ce.addScaledVector(Ct, -Ce.dot(Ct)), Ce.add(St), n.externalVelocityx = Ce.x, n.externalVelocityy = Ce.y, n.externalVelocityz = Ce.z) : n.localVelocityy = o, clearTimeout(e.current), r();
      return;
    }
    p && (a || u) && !i && d ? (clearTimeout(e.current), n.localVelocityy > 0 && (n.localVelocityy = 0), n.jumping = 0, n.falling = 0, n.flying = 1) : i && (n.canFly = 0, n.falling = 1, n.flying = 0);
  }), B("interact", (o) => {
    if (z().dialogMode)
      return;
    const { canInteractWith: i } = /* @__PURE__ */ E();
    if (i.length < 1)
      return;
    let a;
    o ? a = i.find((c) => c.player.playerId === o) : a = i.sort((d, s) => d.player.closestRank - s.player.closestRank)[0], a && (g(`hideMessages_${a.player.playerId}`), A({ interactingWith: a.player }), a.trigger());
  }), B("ctrl_stopJump", () => {
    clearTimeout(e.current), n.jumping = false, n.falling = true, n.driftPressed = false;
  }), B("ctrl_meditateyoyo", () => {
    g(`anim_${t}`, { name: "meditateyoyo", blendDuration: 0.1, reset: true, timeScale: 1 }), g("userAction");
  }), B("ctrl_thankYou", () => {
    g(`anim_${t}`, { name: "thankyou", blendDuration: 0.1, reset: true, timeScale: 1 }), g("userAction");
  }), B("ctrl_dance", () => {
    g(`anim_${t}`, { name: "dance", blendDuration: 0.1, reset: true, timeScale: 1 }), g("userAction");
  }), B("ctrl_bow", () => {
    g(`anim_${t}`, { name: "bow", blendDuration: 0.1, reset: true, timeScale: 1 }), g("userAction");
  });
}, io = oo, Mt = new _.Vector3(), ie = new _.Vector3();
new _.Vector4();
const ye = new _.Quaternion(), He = new _.Quaternion(), tn = (t) => {
  if (!V().physicStarted || t.indexInArray === void 0)
    return;
  const { position: n, quaternion: e } = /* @__PURE__ */ O();
  At(n, e), me.runOnceAfterOnePhysicFrame(() => {
    t.playerStartPositionSet = true, A({ playerStartPositionSet: true });
  });
  const { editorMode: r } = /* @__PURE__ */ E();
  t.sleep = r;
}, so = ({ playerRef: t, playerId: n, playerMesh: e }) => {
  const r = /* @__PURE__ */ $(null), o = /* @__PURE__ */ j((f) => f.playersRoles[n], (f, p) => {
    let h = f && f.length === p && p.length;
    if (!h)
      return false;
    for (let y = 0; y < f.length; y++)
      if (f[y] !== p[y]) {
        h = false;
        break;
      }
    return h;
  }), i = /* @__PURE__ */ he((f) => {
    tn(f);
  }, []), { forceCapacity: a, turnCapacity: c, capsuleRadius: d, capsuleLength: s, halfCapsule: u } = /* @__PURE__ */ V(), m = /* @__PURE__ */ Tn(t, { sleep: true, mass: 1, hitBoxRef: r, slideBonus: 2.5, slideFromSides: 22, slideFrom: 31.8, maxVelocity: 100, startPositionSet: false, attractorx: 0, attractory: 1, attractorz: 0, forceCapacity: a, turnCapacity: c, roles: o || [] }, i);
  return R(() => (console.log("[Player] mouted"), () => {
    console.log("[Player] unmounted");
  }), []), B("physicready", () => {
    tn(m);
  }), R(() => {
    e && (Tt({ grpRef: e, playerApi: m, playerApiReady: true }), Fe({ ref: e }));
  }, [e, m]), B("readPhysicState", ({ state: f, delta: p, isXR: h }) => {
    const y = m;
    if (y.sleep && !y.sitting || !e || y.prevPositionx === void 0)
      return;
    ie.x = y.prevPositionx + (y.positionx - y.prevPositionx) * me.interpolationFactor, ie.y = y.prevPositiony + (y.positiony - y.prevPositiony) * me.interpolationFactor, ie.z = y.prevPositionz + (y.positionz - y.prevPositionz) * me.interpolationFactor, ye.x = y.quaternionx, ye.y = y.quaterniony, ye.z = y.quaternionz, ye.w = y.quaternionw, He.x = y.prevQuaternionx, He.y = y.prevQuaterniony, He.z = y.prevQuaternionz, He.w = y.prevQuaternionw, He.slerp(ye, me.interpolationFactor);
    const { lockRotation: v, birdView: b } = V().sharedCamera;
    !v && !b ? e.quaternion.damp(ye, 10, p) : e.quaternion.copy(ye);
    const P = 0;
    if (Mt.set(0, u - P, 0), Mt.applyQuaternion(e.quaternion), ie.add(Mt), isNaN(ie.x)) {
      console.log("targetPos.x is NaN");
      return;
    }
    e.position.copy(ie), Jr(ie, ye, y);
    const { commonUbo: T } = /* @__PURE__ */ Nn();
    if (T.uniforms[2].value.x = ie.x, T.uniforms[2].value.y = ie.y, T.uniforms[2].value.z = ie.z, e.updateMatrix(), e.matrixWorld.copy(e.matrix), e.api) {
      const k = /* @__PURE__ */ e.api.getParent();
      k.current && k.current.setMatrixAt(e.userData.id, e.matrix);
    }
  }), io(n, m), Kt(n, e, m), M("mesh", { ref: r, position: [0, -u, 0], children: [l("capsuleGeometry", { args: [d, s] }), l("meshBasicMaterial", { wireframe: true, visible: false, color: "green", transparent: true, opacity: 0.4 })] });
}, nn = ({ perks: t }) => {
  const n = /* @__PURE__ */ $(), [e] = /* @__PURE__ */ De((c) => [c.id]), r = /* @__PURE__ */ Ee((c) => c.gl), o = /* @__PURE__ */ he((c) => {
    je().addParticipant(c.playerId);
  }, [r]), i = /* @__PURE__ */ he((c) => {
    je().removeParticipant(c);
  }, []), a = /* @__PURE__ */ jt(e, { distToPlayer: 0, prevDistToPlayer: 0, perks: t, upVector: new _.Vector3(0, 1, 0), activAnimations: {} }, o, i);
  return R(() => {
    Bn({ currentPlayer: a });
  }, [a]), Rn(a), Yr(a), M(H, { children: [l("group", { ref: n, children: l(so, { playerId: e, playerMesh: a, playerRef: n }) }), l(Hr, { playerMesh: a }), l(ro, { playerMesh: a })] });
};
nn.whyDidYouRender = true;
const tt = process.env.NEXT_PUBLIC_PRIVATE_IP ? "loca.lt" : process.env.NEXT_PUBLIC_DOMAIN || "localhost.com", nt = "https", se = (t) => process.env.NEXT_PUBLIC_PRIVATE_IP ? process.env.NEXT_PUBLIC_PRIVATE_IP : t ? typeof window < "u" ? `${nt}://${t}.${tt}` : `${nt}://${tt}/${t}` : `${nt}://${tt}`, rn = /* @__PURE__ */ ar(), ao = ({ renderPriority: t, avatarsViewport: n, avatarsViewportBack: e }) => {
  const r = /* @__PURE__ */ J.useMemo(() => new _.Matrix4(), []), o = /* @__PURE__ */ J.useMemo(() => new _.Vector3(300, 300, 300), []), i = /* @__PURE__ */ J.useRef(/* @__PURE__ */ new Map()), a = /* @__PURE__ */ $t((s) => s.screenshot), c = /* @__PURE__ */ be((s) => s.firstPerson), d = (s) => s < 620 ? 3 : s < 820 ? 4 : 5;
  return X(({ size: s, camera: u, scene: m, gl: f }, p) => {
    const { participants: h, collectionsInCall: y } = /* @__PURE__ */ je(), v = h.size;
    if (f.setClearColor(0, 0), f.clear(), !n || a || Object.keys(y).length === 0 || v <= 1)
      return;
    let b = 0, P = 0;
    if (c) {
      const { grpRef: k } = /* @__PURE__ */ V();
      if (k && k.api) {
        const x = /* @__PURE__ */ k.api.getParent();
        x.current && x.current.setIsActive(k.userData.id, true);
      }
    }
    const { playersMeshes: T } = /* @__PURE__ */ re();
    for (const k in y) {
      const x = y[k], C = [], w = T[x[0]?.playerId]?.parent;
      if (!w)
        continue;
      const F = w.material, S = { x: 99999, y: 0, right: 0, top: 0 };
      for (let U = 0; U < x.length; U++) {
        const L = T[x[U].playerId];
        if (!L || U > 11)
          continue;
        const q = L.userData.id;
        w.getMatrixAt(q, r), i.current.set(q, r.toArray([])), w._inViewports[q] || (C.push(q), w._inViewports[q] = true), r.identity();
        const le = /* @__PURE__ */ d(s.width), Q = U < le, ue = Q ? n[U] : e[U - le];
        if (!ue)
          continue;
        const fe = /* @__PURE__ */ ue.getBoundingClientRect();
        if (!fe)
          continue;
        const { width: pe, height: K, bottom: ve, top: Se, left: Le, right: bn } = fe, kn = -s.height / 2 + (s.height - ve) / 2, Pn = pe * 1.25, Cn = -s.width / 2, Sn = (Q ? b : P) * pe + pe / 2, Mn = kn;
        r.setPosition(Cn + Sn, Mn, Q ? -200 : -100), o.setScalar(Pn), r.scale(o), w.setMatrixAt(q, r), S.right = Math.max(bn * 1.25, S.right), S.x = Math.min(S.x * 1.25, Le), S.y = Math.max(S.y * 1.25, s.height - ve), S.top = Math.max(K * 1.25, S.top), Q ? b++ : P++;
      }
      w.skeleton && w.skeleton.boneTexture && (w.skeleton.boneTexture.needsUpdate = true), f.setScissor(Math.min(0, Math.max(0, S.x - 20)), Math.min(0, Math.max(0, S.y)), Math.min(s.width, S.right), Math.min(s.height, S.top) + 70), f.setScissorTest(true), f && (m.children = [w], f.render(m, u));
      for (let U = 0; U < C.length; U++) {
        const L = C[U];
        w._inViewports[L] = false;
      }
      for (const [U, L] of i.current.entries())
        w.setMatrixAt(U, r.fromArray(L));
      if (i.current.clear(), w.material = F, c) {
        const { grpRef: U } = /* @__PURE__ */ V();
        if (U && U.api) {
          const L = /* @__PURE__ */ U.api.getParent();
          L.current && L.current.setIsActive(U.userData.id, false);
        }
      }
    }
  }, t - 1), null;
};
function lo({ children: t, avatarsViewport: n, avatarsViewportBack: e, renderPriority: r = 1 }) {
  const [o] = /* @__PURE__ */ J.useState(() => new _.Scene());
  return l(H, { children: Rt(M(H, { children: [t, l(ao, { scene: o, avatarsViewport: n, avatarsViewportBack: e, renderPriority: r })] }), o, { events: { priority: r + 1 } }) });
}
const co = () => {
  const t = /* @__PURE__ */ Et((h) => h.startCanvasLoop), n = /* @__PURE__ */ Ee((h) => h.size), [e, r] = /* @__PURE__ */ J.useState(null), [o, i] = /* @__PURE__ */ J.useState(null), a = /* @__PURE__ */ J.useRef([]), c = /* @__PURE__ */ Ye((h) => h.avatarsContainerRef), d = c.current?.children, s = /* @__PURE__ */ J.useCallback(() => {
    if (c.current) {
      if (!d)
        return;
      r(d);
    }
  }, [c, d]);
  J.useEffect(() => {
    s(c);
  }, [c, s, n.width, n.height]);
  const u = /* @__PURE__ */ Ye((h) => h.avatarsContainerRefBack), m = u.current?.children, f = /* @__PURE__ */ J.useCallback(() => {
    if (u.current) {
      if (!m)
        return;
      i(m);
    }
  }, [u, m]);
  J.useEffect(() => {
    f(u);
  }, [u, s, n.width, n.height]);
  const p = /* @__PURE__ */ $t((h) => h.screenshot);
  return X(({ camera: h, gl: y }, v) => {
    const { participants: b, collectionsInCall: P } = /* @__PURE__ */ je(), T = b.size;
    if (!e || p || Object.keys(P).length === 0 || T <= 1)
      return;
    const { playersMeshes: k } = /* @__PURE__ */ re();
    for (const x in P) {
      const C = P[x];
      a.current = [];
      const w = k[C[0]?.playerId]?.parent;
      if (w)
        for (let F = 0; F < C.length; F++) {
          const S = k[C[F].playerId];
          if (!S)
            continue;
          const U = S.userData.id;
          w.getFrustumCulledAt(U) && (a.current.push([w, U]), w.setFrustumCulledAt(U, false));
        }
    }
  }, 5), X(({ camera: h, gl: y }, v) => {
    for (let b = 0; b < a.current.length; b++) {
      const [P, T] = a.current[b];
      P && P.setFrustumCulledAt(T, true);
    }
  }, 12), t ? l(rn.In, { children: l(or, { style: { position: "fixed", inset: 0, pointerEvents: "none" }, dpr: 1, linear: false, flat: false, onCreated: (h) => {
    h.gl.antialias = false, h.gl.alpha = true, h.gl.preserveDrawingBuffer = true, h.gl.setClearColor(0, 0);
  }, children: l(lo, { avatarsViewport: e, avatarsViewportBack: o, renderPriority: 1e4, children: l(Dt, { makeDefault: true, position: [0, 0, 100] }) }) }) }) : null;
};
let uo = 5e3;
const fo = 0.6, po = 50, mo = ({ playerId: t, fromNpc: n, forceMessage: e, playerMesh: r, fontSize: o }) => {
  r.userData;
  const i = /* @__PURE__ */ Z(() => ({ w: 0, h: 0, wn: 0, bgw: 0, t: 0 }), []), [a, c] = /* @__PURE__ */ N("#ffffff"), { t: d } = /* @__PURE__ */ Y("office"), s = /* @__PURE__ */ dt((b) => b.currentPlayer?.userData?.player?.playerId === t), u = /* @__PURE__ */ j((b) => b.usersById[t]?.name), m = /* @__PURE__ */ ne((b) => b.playersByIds[t]?.name), [f, p] = /* @__PURE__ */ N(""), [h, y] = /* @__PURE__ */ N(false);
  B(`hideMessages_${t}`, () => {
    y(true);
  }), B(`update_skin_color_${t}`, (b) => {
    c("#ffffff");
  }), R(() => {
    h && (p(""), g(`hide_name_${t}`, { hide: false }));
  }, [t, h]), X(() => {
    !h && i.t && i.t + uo < window.performance.now() && y(true);
  }, W.renderPriority.default);
  const v = s ? d("you") : u || m || "";
  return v ? l(zn, { "position-y": 0.8, text: e || f, borderColor: n ? "#16EBEB" : a, pseudo: v, pseudoColor: n ? "#1b5a5a" : a, fontSize: o }) : null;
}, ho = ({ playerId: t, playerMesh: n, fromNpc: e = false, forceMessage: r }) => {
  const o = /* @__PURE__ */ $(null), i = /* @__PURE__ */ dt((s) => s.currentPlayer), a = /* @__PURE__ */ be((s) => s.firstPerson), [c, d] = /* @__PURE__ */ N(false);
  return X(function({ camera: u }) {
    if (!n || !i)
      return;
    const { player: m } = n.userData, { player: f } = i.userData;
    if (f && o.current && n) {
      if (!m.fromNpc && m.distToPlayer > po) {
        o.current.visible = false;
        return;
      }
      o.current.visible = true, o.current.position.copy(m.upVector).multiplyScalar(m.modelHeight + On(m) + fo).add(n.position), m.upVector.angleTo(f.upVector) < Math.PI / 6 ? (o.current.children[0].children[0].up.copy(m.upVector), o.current.children[0].children[0].updateMatrix(), o.current.children[0].children[0].lookAt(u.position)) : (o.current.quaternion.copy(n.quaternion), u.directionVector && (u.directionVector.set(0, 0, -1), u.directionVector.applyQuaternion(u.quaternion), u.directionToVector && (u.directionToVector.subVectors(u.position, n.position), u.directionToVector.angleTo(m.dirVector) > Math.PI / 2 ? o.current.children[0].rotation.y = -Math.PI : o.current.children[0].rotation.y = 0)), o.current.children[0].children[0].rotation.set(0, 0, 0)), o.current.updateMatrix(), o.current.updateMatrixWorld(false, false), c === false && d(true);
    }
  }, W.renderPriority.updateAllPositions + 0.1), a && i && t === i.userData.player.playerId ? null : l("group", { ref: o, children: l("group", { children: l("group", { children: c ? l(mo, { playerId: t, fromNpc: e, forceMessage: r, playerMesh: n, fontSize: 0.35 }) : null }) }) });
}, on = (t) => {
  const n = /* @__PURE__ */ Me("isIos"), e = /* @__PURE__ */ Me("isIOS13");
  return n || e ? null : l(ut, { fallback: null, children: l(ho, { ...t }) });
}, go = (t, n) => {
  B(`anim_holo_tp_${n}`, ({ teleportingOut: e = false, reset: r = false, callBack: o, duration: i = 0.3 }) => {
    if (!t) {
      o && o();
      return;
    }
    const { player: a } = t.userData;
    if (!a) {
      o && o();
      return;
    }
    r ? a.dying = e ? 0 : 1 : a.peer.dead = e ? 1 : 0, setTimeout(() => {
      o && o();
    }, i * 1e3);
  });
}, yo = new _.Matrix4(), wo = ({ player: t, charRef: n }) => {
  const e = /* @__PURE__ */ ne((r) => r.playersMeshes);
  return X(function() {
    if (!t || !n || !n.userData.localModel)
      return;
    const o = n.api.getParent().current, i = n.userData.localModel.skeleton, a = i.bones, c = i.boneInverses, { id: d } = n.userData;
    for (let u = 0, m = a.length; u < m; u++) {
      const f = a[u] ? a[u].matrixWorld : yo;
      a[u]._offsetMatrix || (a[u]._offsetMatrix = new _.Matrix4()), a[u]._offsetMatrix.multiplyMatrices(f, c[u]), a[u]._offsetMatrix.toArray(o.instanceBones, 16 * (u + d * a.length));
    }
    const s = /* @__PURE__ */ o.instanceBones.subarray(16 * (d * a.length), 16 * (a.length + d * a.length));
    for (let u = 0; u < t.animGroup.length; u++) {
      const m = t.animGroup[u].NPCid, f = e[m], { id: p } = f.userData;
      o.instanceBones.set(s, 16 * (p * a.length));
    }
  }, W.renderPriority.characterInstanceBones + 0.1), null;
}, xo = /* @__PURE__ */ nr(() => import("@utsubo/renderer").then((t) => ({ default: t.CharacterVrm }))), sn = ({ playerId: t, isVrm: n = false }) => {
  const e = /* @__PURE__ */ ne((c) => c.playersByIds[t]), r = /* @__PURE__ */ ne((c) => c.playersMeshes[t]);
  ne((c) => c.playerNeedsUpdt[t]);
  const [o] = /* @__PURE__ */ De((c) => [c.settings.privacy.showNames]), i = /* @__PURE__ */ j((c) => c.uiSettings);
  go(r, t), Wt(e, t);
  const a = /* @__PURE__ */ $();
  return B(`player_${t}_emote`, (c) => {
    r && a.current.spawnEmoji(c, r.position);
  }), e ? M(H, { children: [n ? l(xo, { mocopi: !e.isNpc, playerId: e.playerId, playerProps: e, perks: e.perks, ref: e.setCharacterRef, colors: e.colors, color: e.color, height: e.height }) : l(Ln, { playerId: e.playerId, playerProps: e, perks: e.perks, ref: e.setCharacterRef, colors: e.colors, color: e.color, height: e.height }), l(Wn, { ref: a }), o && r && !e.isNpc && !i?.isPaintGame ? l(on, { playerId: t, playerMesh: r, fromNpc: e.isNpc }) : null, e.leadAnim && r ? l(wo, { player: e, charRef: r }) : null] }) : null;
}, vo = () => {
  const t = /* @__PURE__ */ ne((o) => o.playersPerCollection), n = /* @__PURE__ */ ne((o) => o.refreshCharacters), [e, r] = /* @__PURE__ */ Z(() => {
    const o = [];
    let i = false;
    for (const a in t) {
      if (a === "vrm") {
        i = true;
        continue;
      }
      o.push(a);
    }
    return [o, i];
  }, [t, n]);
  return l(jn, { name: "BatchedText", children: M(qn, { children: [e.map((o) => l(Hn, { collectionId: o, children: t[o].map((i) => l(sn, { playerId: i.playerId }, i.playerId)) }, o)), r ? t.vrm.map((o) => l(sn, { isVrm: true, playerId: o.playerId }, o.playerId)) : null] }) });
}, bo = (t) => l(ut, { children: l(vo, { ...t }) }), ko = 2, an = /* @__PURE__ */ Math.pow(10, ko), Po = (t, n, e) => [t, n, e].filter(Boolean).length < 3 ? "" : [t, n, e].map((o) => `${parseInt(Math.abs(o) * an).toString(16)}${Math.sign(o) !== -1 ? "N" : "S"}`).join(""), Co = (t) => {
  if (!t)
    return null;
  const n = new RegExp(/(.+?)([NS])/gmi), e = /* @__PURE__ */ [n.exec(t), n.exec(t), n.exec(t)].filter(Boolean);
  return e.length < 3 ? null : e.map(([r]) => {
    const o = /* @__PURE__ */ r.substr(0, r.length - 1), i = /* @__PURE__ */ r.substr(-1);
    return parseInt(o, 16) / an * (i === "S" ? -1 : 1);
  });
}, rt = ["B", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], So = (t) => {
  if (!Number.isFinite(t) || Number.isNaN(t))
    return t;
  if (t === 0)
    return ` 0${rt}`;
  const n = t < 0, e = n ? "-" : "";
  if (n && (t = -t), t < 1)
    return `${e}${t}${rt[0]}`;
  const r = /* @__PURE__ */ Math.min(Math.floor(Math.log10(t) / 3), rt.length - 1);
  return t /= 1e3 ** r, t = t.toPrecision(3), `${e}${t}${rt[r]}`;
}, ae = ({ label: t, onClick: n, tr: e = "common", disabled: r, isAsync: o }) => {
  const { t: i } = /* @__PURE__ */ Y(e), [a, c] = /* @__PURE__ */ N(false);
  return M(Mo, { className: "secfont", onClick: async () => {
    if (o) {
      if (a)
        return;
      c(true), await n(), c(false);
    } else
      n();
  }, disabled: r, pending: a.toString(), children: [l("span", { children: i(t) }), a ? l(_o, {}) : null] });
}, Mo = I.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 25px;
  text-transform: uppercase;

  background: rgba(45, 45, 45, 0.98);
  border: 1.2px solid #ffffff;
  border-radius: 99px;

  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  align-items: center;
  letter-spacing: 0.1em;

  ${(t) => t.disabled ? `
    opacity: 0.25;
  ` : ""}

  span {
    position: relative;
    z-index: 1;

    ${(t) => t.pending !== "false" ? `
      opacity: 0.0;
    ` : ""}
  }

  @media all and (pointer: fine) {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      background: #fff;
      transition: opacity 0.2s ease;
      border-radius: 99px;
    }

    span {
      transition: color 0.2s ease;
    }

    ${(t) => t.disabled ? "" : `
      &:hover {
        span {
          color: #2d2d2d;
        }
        &::before {
          opacity: 1;
        }
      }
    `}
  }
`, _o = I.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50%;
  height: 2px;
  background: #ffffff;
  transform: translateX(-50%) translateY(-50%);
  opacity: 0.8;
  animation: pulse 1s ease-in-out infinite;
`, ln = ({ file: t }) => {
  const { t: n } = /* @__PURE__ */ Y("office");
  if (!t.isLinkUrl)
    return null;
  const e = /* @__PURE__ */ Z(() => {
    const r = t.metadata?.linkUrl;
    return r ? r.length > 128 ? `${r.substr(0, 128)}...` : r : "";
  }, [t.metadata?.linkUrl]);
  return M(Io, { children: [l(Ao, { children: n("link-url-leaving-warn-title") }), l(To, { dangerouslySetInnerHTML: { __html: n("link-url-leaving-warn-description").replace("{{displayLink}}", e) } }), l(ae, { label: n("link-url-leaving-warn-open"), onClick: async () => {
    if (typeof window > "u")
      return;
    let r = t.metadata?.linkUrl;
    /^https?:\/\//i.test(r) || (r = `https://${r}`), window.open(r, "_tab");
  } })] });
}, Io = I.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  isolation: isolate;
  background: #2d2d2d;
  border-radius: 10px;
  max-width: 400px;
  text-align: center;
  flex-grow: 1;

  & > div {
    width: 100%;
  }

  @media all and (max-width: 600px) {
    min-width: auto;
    max-width: 100%;
  }
`, Ao = I.div`
  font-weight: 700;
  font-size: 1.5rem;
  margin-bottom: 16px;
`, To = I.div`
  white-space: normal;
  word-wrap: break-word;
  margin-bottom: 32px;
`, cn = (t, n) => {
  const e = /* @__PURE__ */ $(), r = /* @__PURE__ */ $();
  return he((...i) => {
    e.current && clearTimeout(e.current), r.current = i || void 0, e.current = setTimeout(() => {
      t(...r.current), r.current = void 0;
    }, n);
  }, [t, n]);
}, _t = new _.Vector3(), Eo = [{ fileTypes: ["image/gif", "image/png", "image/apng", "image/jpg", "image/jpeg", "image/avif", "image/webp"], colorScheme: ["#777777", "#999999"], icon: "image" }, { fileTypes: ["application/pdf"], colorScheme: ["#aa1111", "#cc1111"], icon: "file" }, { fileTypes: ["application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation"], colorScheme: ["#d49748", "#9f7f20"], icon: "file" }, { fileTypes: ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"], colorScheme: ["#32508d", "#35589c"], icon: "file" }, { fileTypes: ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.spreadsheetml.document", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"], colorScheme: ["#397b49", "#367645"], icon: "file" }], dn = /* @__PURE__ */ rr(({ extension: t }, n) => {
  const { scene: e } = /* @__PURE__ */ Gn(ee[`/glb/${t}.glb`]);
  return l("primitive", { ref: n, object: e.children[0].geometry, attach: "geometry" });
});
dn.displayName = "FileGeometry";
const $o = ({ file: t, onClick: n, ...e }) => {
  const r = /* @__PURE__ */ $(), o = /* @__PURE__ */ Z(() => ft.lookup(t.filename), [t.filename]), i = /* @__PURE__ */ Z(() => t.isLinkUrl ? "url" : t.isPostIt ? "postit" : Eo.find((a) => a.fileTypes.includes(o))?.icon || "file", [t, o]);
  return X(({ camera: a }) => {
    r.current && (r.current.traverse((c) => {
      c.updateMatrix(), c.updateMatrixWorld(false, false), c.matrixWorldNeedsUpdate = false;
    }), _t.copy(a.position), _t.y = r.current.position.y, r.current.lookAt(_t));
  }), l(ut, { fallback: null, children: l(Kn, { ref: r, position: t.position, ...e, onClick: (a) => {
    a.stopPropagation(), n && n(r.current);
  }, children: l(dn, { extension: i }) }) });
}, Do = () => {
  const t = /* @__PURE__ */ j((f) => f.sharedFiles, (f, p) => f === p), [n] = /* @__PURE__ */ j((f) => [f.dom]), [e, r] = /* @__PURE__ */ N(), o = /* @__PURE__ */ $(), i = /* @__PURE__ */ O(), [a, c] = /* @__PURE__ */ j((f) => [f.sharedFileEditor, f.sharedFileFocused]), [d, s] = /* @__PURE__ */ N();
  X(() => {
    o.current && (o.current.traverse((f) => {
      f.updateMatrix();
    }), o.current.updateMatrixWorld(true));
  });
  const u = /* @__PURE__ */ cn(async () => {
    const [f, p] = e, { id: h, uploaded_by: y } = f;
    if (y !== i.id || !p)
      return;
    const v = await O().user.getIdToken(), { workspace: b, microverseId: P } = /* @__PURE__ */ E(), T = await fetch(`${se(b)}/api/${P}/shared/update`, { method: "POST", body: JSON.stringify({ fileId: h, ...f, position: [p.position.x, p.position.y, p.position.z] }), headers: { authorization: `Bearer ${v}` } }), { success: k } = await T.json();
    !k && d && p.position.copy(d), s(null);
  }, 1e3);
  if (!t)
    return null;
  const m = (f) => {
    g("closeSubMenu"), A({ sharedFileView: f, sharedFileFocused: f });
  };
  return M(Qn, { castShadow: true, receiveShadow: true, children: [l(Jn, { side: _.DoubleSide, vertexColors: true }), t.map((f, p) => {
    const { id: h, uploaded_by: y } = f;
    return l($o, { file: f, onClick: async (v) => {
      y === i.id ? (A({ sharedFileEditor: f, sharedFileFocused: f }), r([f, v])) : f.isLinkUrl ? g("openModal", l(ln, { file: f })) : m(f), g("closeSubMenu"), A({ sharedFileEditor: f, sharedFileFocused: f }), r([f, v]);
    }, onPointerEnter: () => {
      A({ sharedFileFocused: f });
    }, onPointerLeave: () => {
      A({ sharedFileFocused: false });
    } }, `${h || f.filename}_${y}_${p}`);
  }), a && e && e.length > 0 ? l(Xn, { object: e[1], ref: o, mode: "translate", domElement: n?.current || n, onMouseUp: () => {
    u();
  }, onMouseDown: () => {
    const [, f] = e;
    f && s(f.position.clone());
  }, onChange: () => {
    if (!e)
      return;
    const [, f] = e;
    f && (f.updateMatrix(), f.matrixWorld.copy(f.matrix), f.matrixWorldNeedsUpdate = false);
  } }) : null] });
};
function ot(t) {
  try {
    return structuredClone(t);
  } catch {
    const e = /* @__PURE__ */ JSON.stringify(t);
    return JSON.parse(e);
  }
}
const it = I.div`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);

  &.cntr {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`, un = I.div`
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 800px;
  width: 100%;
  height: 500px;
  z-index: 1;
  transform: translateX(-50%) translateY(-50%);
  background-color: #2c2c2c;
  border-radius: 12px;
  color: #ffffff;
`, st = I.div`
  display: flex;
  flex-direction: column;
  margin: 40px;
  width: calc(100% - 80px);
  height: calc(100% - 80px);
`, at = I.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`;
I.div`
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
`, I.table`
  thead td {
    color: #ffffff;
  }

  tr {
    color: #cccccc;
  }

  td {
    white-space: nowrap;
    padding: 8px;
  }
`;
const It = I.div`
  font-size: 24px;
  font-weight: bold;
`;
I.div`
  font-size: 13px;
  font-weight: bold;
`, I.div`
  & > * {
    margin: 8px 0;
  }
`;
const Fo = I.div`
  position: relative;
  font-size: 13px;
`;
I.input`
  margin-left: auto;
  border-radius: 3px;
  background: transparent;
  color: #cccccc;
  font-size: 14px;
  width: 330px;
  border: 1px solid #565656;
  padding: 8px;
`, I.div`
  display: inline-block;
  margin-right: 4px;
  padding-right: 2px;
  font-size: 12px;

  &:hover {
    color: #ffffff;
  }
`;
const Uo = I.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: max(300px, 50vmin);
  height: 2px;
  background: #ffffff;
  transform: translateX(-50%) translateY(-50%);
  opacity: 0.8;
  animation: pulse 1s ease-in-out infinite;
`, fn = () => M("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 11 10", children: [l("g", { clipPath: "url(#a)", children: l("path", { d: "M1.5 4.4c-.33137 0-.6.26863-.6.6s.26863.6.6.6V4.4Zm8.42426 1.02426c.23434-.23431.23434-.61421 0-.84852L6.10589.757359c-.23432-.234314-.61422-.234314-.84853 0-.23432.234315-.23432.614211 0 .848531L8.65147 5 5.25736 8.39411c-.23432.23432-.23432.61422 0 .84853.23431.23432.61421.23432.84853 0l3.81837-3.81838ZM1.5 5c0 .6.00002.6.00006.6H9.5V4.4H1.50006C1.50002 4.4 1.5 4.4 1.5 5Z", fill: "#fff" }) }), l("defs", { children: l("clipPath", { id: "a", children: l("path", { fill: "#fff", d: "M.5 0h10v10H.5z" }) }) })] }), Ge = ({ label: t, onClick: n, cls: e = "", arrow: r = true, disable: o, tr: i = "common" }) => {
  const { t: a } = /* @__PURE__ */ Y(i), c = /* @__PURE__ */ $(null);
  return M(Vo, { ref: c, onClick: () => {
    n && n(), c.current && c.current.blur();
  }, className: `${e} ${o ? "disable" : ""} `, children: [l("span", { className: "secfont", children: a(t) }), r ? l(fn, {}) : null] });
}, Vo = I.button`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 20px 40px;
  gap: 10px;

  min-width: 200px;
  height: 51px;

  background: #2d2d2d;
  border-radius: 53px;

  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  transition: opacity 0.2s ease;

  svg {
    width: 10px;
  }

  span,
  svg {
    position: relative;
    z-index: 1;
  }

  &.white {
    background: #fff;
    span {
      color: #2d2d2d;
    }
  }

  &.alert {
    background: #f33182;
  }

  &.blue {
    background: #093cbe;
  }

  &.disable {
    opacity: 0.5;
    pointer-events: none;
  }

  &.nomw {
    min-width: auto;
  }
  @media all and (pointer: fine) {
    &::before {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      width: calc(100% - 4px);
      height: calc(100% - 4px);
      border-radius: 50px;
      background: #fff;
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    &.white {
      &::before {
        background: #2d2d2d;
      }
      svg {
        path {
          fill: #2d2d2d;
        }
      }
    }

    &.bluehvr {
      &::before {
        background: #093cbe;
      }
    }

    &.alert {
      &::before {
        background: #2d2d2d;
      }
    }

    &:hover {
      &::before {
        opacity: 0.2;
      }
      &.white {
        span {
          color: #fff;
        }
        &::before {
          opacity: 1;
        }
        svg {
          path {
            fill: #fff;
          }
        }
      }
      &.alert {
        &::before {
          opacity: 1;
        }
      }
    }
  }
`, we = ({ label: t, desc: n, children: e, tr: r = "office" }) => {
  const { t: o } = /* @__PURE__ */ Y(r);
  return M(Bo, { children: [t ? l("label", { className: "secFontTxtSml", htmlFor: t, children: o(t) }) : null, n ? l("p", { className: "secFontTxtSmlLight", children: o(n) }) : null, e] });
}, Bo = I.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  label,
  p {
    color: #fff;
  }

  label {
    text-transform: capitalize;
  }

  input,
  textarea {
    width: 100%;
    padding: 10px 23px;
    height: 50px;
    background: #1d1d1d;
    border-radius: 5px;
  }

  textarea {
    padding: 15px 23px;
  }

  input:-webkit-autofill {
    -webkit-text-fill-color: #fff;
    -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  select {
    background: #1d1d1d;
    border-radius: 5px;
    padding: 15px 23px;
    outline: none;

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  input,
  select {
    color: #ffffff;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  @media (pointer: coarse) {
    input,
    textarea {
      font-size: 16px;
      line-height: 24px;
    }
  }
`, pn = ({ defaultBoardName: t, onSubmit: n, onDelete: e, onCancel: r, update: o = false }) => {
  const i = /* @__PURE__ */ $({ boardName: t }), a = /* @__PURE__ */ $(ot(i.current)), { t: c } = /* @__PURE__ */ Y("office");
  return M(st, { children: [l(It, { children: c(o ? "update-post-it" : "add-post-it-office") }), M(Ro, { style: { flexGrow: 1, marginTop: 16 }, children: [l(we, { label: "post-it-board-name", children: l("input", { defaultValue: t, type: "text", onChange: (d) => {
    a.current.boardName = d.target.value;
  } }) }), o && e ? l("div", { children: l(Ge, { label: "delete", cls: "alert", arrow: false, onClick: e, tr: "office" }) }) : null] }), M(at, { children: [l(ae, { label: "back-btn", isAsync: true, onClick: async () => {
    n && r();
  } }), l(ae, { label: "save", tr: "office", isAsync: true, onClick: async () => {
    n && await n(a.current);
  } })] })] });
}, Ro = I.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`, No = ({ defaultFilename: t, defaultDescription: n, onSubmit: e, onDelete: r, onCancel: o, update: i = false }) => {
  const a = /* @__PURE__ */ $({ displayName: t, description: n }), c = /* @__PURE__ */ $(ot(a.current)), { t: d } = /* @__PURE__ */ Y("office");
  return M(st, { children: [l(It, { children: i ? d("update-file") : d("add-filename-office", { filename: t }) }), M(Oo, { style: { flexGrow: 1, marginTop: 16 }, children: [l(we, { label: "file-name", children: l("input", { type: "text", defaultValue: t, onChange: (s) => {
    c.current.displayName = s.target.value;
  } }) }), l(we, { label: "file-desc", children: l("input", { type: "text", defaultValue: n, onChange: (s) => {
    c.current.description = s.target.value;
  } }) }), r ? l("div", { children: l(Ge, { label: "delete", cls: "alert", arrow: false, onClick: r, tr: "office" }) }) : null] }), M(at, { children: [l(ae, { label: "back-btn", isAsync: true, onClick: async () => {
    e && o();
  } }), l(ae, { label: "save", tr: "office", isAsync: true, onClick: async () => {
    e && await e(c.current);
  } })] })] });
}, Oo = I.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`, mn = ({ defaultLinkUrl: t, defaultLinkTitle: n, onSubmit: e, onDelete: r, onCancel: o, update: i = false }) => {
  const a = /* @__PURE__ */ $({ linkUrl: t, linkTitle: n }), c = /* @__PURE__ */ $(ot(a.current)), { t: d } = /* @__PURE__ */ Y("office");
  return M(st, { children: [l(It, { children: d(i ? "update-link-url" : "add-link-url-office") }), M(zo, { style: { flexGrow: 1, marginTop: 16 }, children: [l(we, { label: "link-url-title", children: l("input", { defaultValue: n, type: "text", onChange: (s) => {
    c.current.linkTitle = s.target.value;
  } }) }), l(we, { label: "link-url-url", children: l("input", { defaultValue: t, type: "text", onChange: (s) => {
    c.current.linkUrl = s.target.value;
  } }) }), i && r ? l("div", { children: l(Ge, { label: "delete", cls: "alert", arrow: false, onClick: r, tr: "office" }) }) : null] }), M(at, { children: [l(ae, { label: "back-btn", isAsync: true, onClick: async () => {
    e && o();
  } }), l(ae, { label: "save", tr: "office", isAsync: true, onClick: async () => {
    e && await e(c.current);
  } })] })] });
}, zo = I.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`, Lo = ({ sharedFileView: t }) => l(Ho, { children: l("p", { children: t?.metadata?.displayName || t.filename }) }), Wo = ({ sharedFileView: t, url: n }) => M(jo, { children: [l(Lo, { sharedFileView: t }), M(qo, { children: [l(xe, { "aria-label": "download", onClick: () => {
  const e = /* @__PURE__ */ document.createElement("a");
  e.href = n, e.download = t.filename, document.body.appendChild(e), e.click(), document.body.removeChild(e);
}, children: l("img", { src: ee["/icons/tools/download.svg"], alt: "download" }) }), l(xe, { className: "close", "aria-label": "close", onClick: () => {
  A({ sharedFileEditor: null, sharedFileView: null, sharedFileFocused: false });
}, children: l("img", { src: ee["/icons/close.svg"], alt: "close" }) })] })] }), jo = I.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  padding: 8px 55px;
  min-height: 80px;
  z-index: 1;

  background: #2d2d2d;
  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.5);

  @media all and (max-width: 767px) {
    padding: 8px 20px;
    min-height: 60px;
  }
`, qo = I.div`
  display: flex;
  align-items: center;
  gap: 20px;
`, xe = I.button`
  font-size: 0;
  width: ${(t) => t.small ? 30 : 40}px;
  height: ${(t) => t.small ? 30 : 40}px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: auto;
    clip-path: none;
  }

  &.close {
    img {
      width: 36px;
    }
  }
  &.edit {
    img {
      width: 36px;
    }
  }

  @media all and (pointer: fine) {
    transition: opacity 0.2s ease;
    &:hover {
      opacity: 0.7;
    }
  }
`, Ho = I.div`
  display: flex;
  align-items: center;
  gap: 14px;

  & > p {
    font-family: 'Mundial';
    font-weight: 600;
    font-size: 19px;
    line-height: 26px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }

  @media all and (max-width: 767px) {
    & > p {
      font-size: 14px;
    }
  }
`, Go = ({ sharedFile: t, setShowEditModal: n }) => {
  const e = /* @__PURE__ */ O(), r = { update: !!t?.id, onDelete: async () => {
    const { id: i, uploaded_by: a } = t;
    if (a !== e.id)
      return;
    g("showSpinnerLoader", true);
    const c = await O().user.getIdToken(), { workspace: d, microverseId: s } = /* @__PURE__ */ E();
    await (await fetch(`${se(d)}/api/${s}/shared/delete`, { method: "POST", body: JSON.stringify({ fileId: i, isFile: t.isFile }), headers: { authorization: `Bearer ${c}` } })).json(), g("showSpinnerLoader", false), n(false), A({ sharedFileEditor: null });
  }, onSubmit: async (i) => {
    const { id: a, uploaded_by: c } = t;
    if (c !== e.id)
      return;
    g("showSpinnerLoader", true);
    const d = await O().user.getIdToken(), { workspace: s, microverseId: u } = /* @__PURE__ */ E();
    await (await fetch(`${se(s)}/api/${u}/shared/update`, { method: "POST", body: JSON.stringify({ fileId: a, ...t, metadata: i }), headers: { authorization: `Bearer ${d}` } })).json(), g("showSpinnerLoader", false), n(false);
  }, onCancel: () => {
    n(false);
  } }, o = /* @__PURE__ */ Z(() => t ? t.isLinkUrl ? l(mn, { defaultLinkTitle: t?.metadata?.linkTitle, defaultLinkUrl: t?.metadata?.linkUrl, ...r }) : t.isPostIt ? l(pn, { defaultBoardName: t?.metadata?.boardName, ...r }) : l(No, { defaultFilename: t?.metadata?.displayName || t.filename, defaultDescription: t?.metadata?.description || "", ...r }) : null, [t]);
  return l(it, { style: { zIndex: 100 }, children: l(un, { children: o }) });
}, Qo = () => {
  const [t, n] = /* @__PURE__ */ N(false), [e, r] = /* @__PURE__ */ N(false), [o] = /* @__PURE__ */ j((i) => [i.sharedFileEditor]);
  return Bt(() => {
    o ? setTimeout(() => {
      r(true);
    }, 1) : r(false);
  }, [o]), o ? M(H, { children: [M(Jo, { className: e ? "show" : "", children: [l(xe, { className: "close", "aria-label": "close", onClick: () => {
    A({ sharedFileEditor: null, sharedFileFocused: false });
  }, children: l("img", { src: ee["/icons/close.svg"], alt: "close" }) }), M(Xo, { children: [l(xe, { className: "edit", "aria-label": "edit", onClick: () => {
    n(true);
  }, children: l("img", { src: ee["/icons/tools/edit-2.svg"], alt: "edit" }) }), l(Ge, { label: "view", tr: "office", cls: "white", arrow: false, isAsync: true, onClick: async () => {
    if (o.isLinkUrl) {
      g("openModal", l(ln, { file: o }));
      return;
    }
    A({ sharedFileEditor: null, sharedFileView: o });
  } })] })] }), t ? l(Go, { setShowEditModal: n, sharedFile: o }) : null] }) : null;
}, Jo = I.div`
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100vw - 50px);
  padding: 25px 30px;
  background: #2d2d2d;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  pointer-events: none;

  transition: transform 0.5s ease;
  transform: translate3d(0, -100%, 0);

  &.show {
    pointer-events: all;
    transform: translate3d(0, 0, 0);
  }

  @media all and (max-width: 767px) {
    width: 100vw;
    z-index: 3;
    padding: 20px;
  }
`, Xo = I.div`
  display: inline-flex;
  justify-content: space-between;
  gap: 20px;

  .white {
    min-width: auto;
    padding: 14px 40px;
    height: auto;
  }
`, hn = ["#fff8ae", "#b9f2fe", "#b9fcad", "#f7c8c7", "#b8c8fa", "#b8c8fa"], gn = 999, yn = 32, Ko = ({ context: t, onClose: n }) => {
  const e = /* @__PURE__ */ $(null), r = /* @__PURE__ */ $([0, 0]), o = (a) => {
    e.current === null && (e.current = [a.clientX, a.clientY]);
  }, i = () => {
    const { initialPosition: a, onCommit: c } = t;
    c([(a[0] || 0) + r.current[0], (a[1] || 0) + r.current[1]]), r.current = [0, 0], e.current = null, n();
  };
  return l(ai, { onPointerDown: (a) => o(a), onPointerUp: () => i(), onPointerLeave: () => i(), onPointerMove: (a) => {
    o(a);
    const { initialPosition: c, onMove: d } = t, s = a.clientX - e.current[0], u = a.clientY - e.current[1];
    r.current[0] += s, r.current[1] += u, Math.abs(r.current[0] + r.current[1]) > 0 && d([(c[0] || 0) + r.current[0], (c[1] || 0) + r.current[1]]), e.current = [a.clientX, a.clientY];
  } });
}, Yo = ({ data: t, isActivePostIt: n, onUpdatePostIt: e, onAddNewPostIt: r, onDeletePostIt: o, onClosePostItBoard: i, ...a }) => {
  const [c, d] = /* @__PURE__ */ N(false), [s, u] = /* @__PURE__ */ N(false), m = /* @__PURE__ */ $(null), { order: f, id: p, position: h, title: y, content: v, colorVariant: b } = t, P = !!e, T = P && !!n, k = ({ ...x }) => {
    if (!P)
      return;
    const C = { ...structuredClone(t), ...x };
    Object.keys(x).length > 0 && e(C);
  };
  return M(H, { children: [s && l(Ko, { context: s, onClose: () => u(false) }), M(ei, { order: f, position: h, ref: m, ...a, children: [M(ti, { children: [M(ni, { onClick: (x) => {
    if (P) {
      if (c) {
        d(false);
        return;
      }
      if (x.metaKey || x.ctrlKey) {
        k({ colorVariant: ((b || 0) + 1) % (hn.length - 1) });
        return;
      }
    }
  }, children: [l(ri, { readOnly: !P, rows: 1, onBlur: (x) => k({ title: x.target.value }), onKeyUp: (x) => k({ title: x.target.value }), defaultValue: y }), l(xe, { small: "true", className: "close", "aria-label": "close", onClick: (x) => {
    x.preventDefault(), i();
  }, children: l("img", { src: ee["/icons/close.svg"], alt: "close" }) })] }), l(oi, { colorVariant: hn[b || 0], children: l(ii, { readOnly: !P, rows: 1, onBlur: (x) => k({ content: x.target.value }), onKeyUp: (x) => k({ content: x.target.value }), defaultValue: v }) })] }), l(si, { active: T, children: T && M(H, { children: [l(xe, { small: "true", className: "move-post-it", "aria-label": "move-post-it", onPointerDown: () => {
    u({ initialPosition: [...h], onMove: (x) => {
      d(true), m.current.style.top = `calc(50% + ${x[1]}px)`, m.current.style.left = `calc(50% + ${x[0]}px)`;
    }, onCommit: (x) => {
      k({ position: x });
    } });
  }, children: l("img", { src: ee["/icons/file-sharing/post-it-move.svg"], alt: "move post it" }) }), l(xe, { small: "true", className: "new-post-it", "aria-label": "new-post-it", onClick: () => {
    r();
  }, children: l("img", { src: ee["/icons/file-sharing/post-it-add-new.svg"], alt: "add new post it" }) }), l(xe, { small: "true", className: "delete-post-it", "aria-label": "delete-post-it", onClick: () => {
    o();
  }, children: l("img", { src: ee["/icons/file-sharing/post-it-delete.svg"], alt: "delete post it" }) })] }) })] }, p)] });
}, Zo = ({ file: t }) => {
  const n = /* @__PURE__ */ O(), e = t.uploaded_by === n.id, [r, o] = /* @__PURE__ */ N(t.metadata.postItBoard || []), [i, a] = /* @__PURE__ */ N(null), [c, d] = /* @__PURE__ */ N(null), s = /* @__PURE__ */ cn(async (p, h) => {
    const y = await O().user.getIdToken(), { workspace: v, microverseId: b } = /* @__PURE__ */ E();
    await (await fetch(`${se(v)}/api/${b}/shared/update`, { method: "POST", body: JSON.stringify({ fileId: t.id, metadata: { postItBoard: p } }), headers: { authorization: `Bearer ${y}` } })).json(), h(), d(null);
  }, 3e3), u = (p) => {
    if (!e)
      return;
    const h = /* @__PURE__ */ structuredClone(p);
    h.position[0] -= 10, h.position[1] -= 10;
    const y = { id: Math.random(), title: "New Post-It", position: [p.position[0] + 10, p.position[1] + 10], content: "", order: r.length + 1, colorVariant: 0 }, v = [...r.filter((b) => b.id !== h.id), h, y];
    d(new Promise((b) => {
      s(v, b);
    })), o(v);
  }, m = (p) => {
    if (!e)
      return;
    const h = [...r.filter((y) => y.id !== p.id), p];
    d(new Promise((y) => {
      s(h, y);
    })), o(h);
  }, f = (p) => {
    if (!e)
      return;
    const h = [...r.filter((y) => y.id !== p.id)];
    d(new Promise((y) => {
      s(h, y);
    })), o(h);
  };
  return t.isPostIt ? l(H, { children: r.map((p) => l(Yo, { data: p, isActivePostIt: i === p.id, onPointerOver: () => a(p.id), onAddNewPostIt: r.length < yn ? () => u(p) : null, onUpdatePostIt: (h) => m(h), onDeletePostIt: () => f(p), onClosePostItBoard: async () => {
    c && (g("showSpinnerLoader", true), await c, g("showSpinnerLoader", false)), A({ sharedFileEditor: null, sharedFileView: null, sharedFileFocused: false });
  } }, p.id)) }) : null;
}, ei = I.div`
  position: absolute;
  top: calc(50% + ${(t) => t.position[1] || 0}px);
  left: calc(50% + ${(t) => t.position[0] || 0}px);
  transform: translateX(-50%) translateY(-50%);
  z-index: ${(t) => gn + (t.order || 0)};
`, ti = I.div`
  border-radius: 18px;
  overflow: hidden;
  width: 380px;
  box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.2);
`, ni = I.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background-color: #1f1f1f;
  color: #ffffff;
`, ri = I.textarea`
  border: none;
  overflow: auto;
  outline: none;
  box-shadow: none;
  resize: none;
  background: transparent;
  font-weight: 700;
  font-size: 1.3rem;
  color: #ffffff;
  white-space: nowrap;
`, oi = I.div`
  overflow-x: hidden;
  overflow-y: scroll;
  height: 240px;
  background-color: ${(t) => t.colorVariant};
  transition: background-color 0.3s ease;
`, ii = I.textarea`
  border: none;
  overflow: auto;
  outline: none;
  box-shadow: none;
  resize: none;
  background: transparent;
  color: #000000;
  line-height: 1.75;
  width: 100%;
  height: 100%;
  padding: 20px 30px;
`, si = I.div`
  position: absolute;
  top: 20px;
  right: ${(t) => t.active ? -5 : 15}px;
  opacity: ${(t) => t.active ? 0.75 : 0};
  transform: translateX(100%);
  width: 30px;
  height: 30px;
  transition: right 0.3s ease, opacity 0.2s ease;

  & > button {
    margin-bottom: 10px;
  }
`, ai = I.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: ${gn + yn + 1};
`, li = ({ fileId: t }) => {
  const [n, e] = /* @__PURE__ */ N(false), [r, o] = /* @__PURE__ */ N(null), [i, a] = /* @__PURE__ */ N(null), { workspace: c, microverseId: d } = /* @__PURE__ */ E(), s = /* @__PURE__ */ Xe(`https://storage.googleapis.com/konpi-app/${c}/${d}/shared/${t}`);
  return R(() => {
    const u = new Image();
    u.src = s, u.onload = () => {
      e(true), o(u.width), a(u.height);
    };
  }, [s]), n ? l("div", { className: "image-preview", style: { backgroundImage: `url(${s})`, maxWidth: r ? `${r}px` : void 0, maxHeight: i ? `${i}px` : void 0 } }) : l(Uo, {});
}, ci = ({ url: t }) => {
  const n = /* @__PURE__ */ Xe(t);
  return l(fi, { children: l("embed", { src: n, type: "application/pdf", width: "100%", height: "100%", title: "pdf-visualizer" }) });
}, di = () => {
  const [t] = /* @__PURE__ */ j((d) => [d.sharedFileView]), { t: n } = /* @__PURE__ */ Y("office"), { workspace: e, microverseId: r } = /* @__PURE__ */ E(), o = t?.fileNameBucket, i = /* @__PURE__ */ Z(() => {
    if (!t)
      return false;
    const d = ["image", "application/pdf"], s = /* @__PURE__ */ ft.lookup(t.filename);
    let u = false;
    return d.forEach((m) => {
      s?.startsWith(`${m}`) && (u = m);
    }), u;
  }, [t?.filename]);
  if (!t)
    return null;
  if (t.isPostIt)
    return l(Zo, { file: t });
  const a = `https://storage.googleapis.com/konpi-app/${e}/${r}/shared/${o}`, c = { image: l(li, { fileId: o }), "application/pdf": l(ci, { url: a }) }[i];
  return M(it, { style: { zIndex: 100 }, children: [l(ui, { children: c || l("div", { className: "pna", children: n("preview-not-available") }) }), l(Wo, { sharedFileView: t, url: a })] });
}, ui = I.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);

  & > * {
    position: absolute;
    top: calc(50% + 40px);
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  }

  & > .image-preview {
    width: 75vmin;
    height: 75vmin;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 2;
  }

  .pna {
    font-family: 'Mundial';
    font-weight: 600;
    font-size: 16px;
    line-height: 55px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #ffffff;
  }

  @media all and (max-width: 767px) {
    & > * {
      top: calc(50% + 30px);
    }

    & > .image-preview {
      width: 90vmin;
      height: 80vmin;
    }
  }
`, fi = I.div`
  top: 80px;
  left: 0;
  transform: none;
  width: 100%;
  height: calc(100% - 80px);

  @media all and (max-width: 767px) {
    top: 60px;
    height: calc(100% - 60px);
  }
`, pi = async (t, n, e, r) => {
  const { workspace: o, microverseId: i } = /* @__PURE__ */ E(), a = await O().user.getIdToken(), c = await fetch(`${se(o)}/api/${i}/shared/upload`, { method: "POST", body: JSON.stringify({ position: n, filename: e, metadata: r }), headers: { authorization: `Bearer ${a}` } }), { url: d, fields: s, docId: u } = await c.json(), m = new FormData();
  Object.entries({ ...s, file: t.file }).forEach(([p, h]) => {
    m.append(p, h);
  });
  const f = await fetch(d, { method: "POST", body: m, mode: "cors" });
  return await fetch(`${se(o)}/api/${i}/shared/confirmupload`, { method: "POST", body: JSON.stringify({ docId: u }), headers: { authorization: `Bearer ${a}` } }), f.ok ? console.log("Uploaded successfully!") : console.error("Upload failed."), { success: f.ok, fileId: u };
}, mi = ({ filename: t, error: n, file: e, uploaded: r, fileIndex: o, files: i, uploadSteps: a, setUploadStep: c, setFiles: d }) => {
  const s = /* @__PURE__ */ $(null), u = /* @__PURE__ */ $(null), m = [];
  if (!e?.file)
    return null;
  let f = 0;
  m.push(l("td", { children: M(Fo, { children: [t.substr(0, 32), t.length > 32 ? "..." : ""] }) }, f++));
  const p = (h, y) => {
    i?.[0] && (i[0][4] = { displayName: s.current.value, description: u.current.value }, d(i));
  };
  return M(hi, { children: [l(we, { label: "file-name", children: l("input", { ref: s, type: "text", defaultValue: t, onChange: (h) => {
    p();
  } }) }), l(we, { label: "file-desc", children: l("input", { ref: u, type: "text", defaultValue: "", onChange: (h) => {
    p();
  } }) })] });
}, hi = I.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  & > div {
    width: 100%;
  }
`, wn = ({ label: t, desc: n, isError: e, cancel: r }) => {
  const { t: o } = /* @__PURE__ */ Y("office");
  return M(it, { className: "cntr", onClick: r || null, children: [l(gi, {}), M(yi, { children: [l("img", { className: e ? "err-img" : "", src: ee[`/icons/file-sharing/file-drop${e ? "-error" : ""}.svg`], alt: "file-drop" }), M("div", { children: [l("h3", { className: "secFontTxtBig", dangerouslySetInnerHTML: { __html: o(t) } }), n ? l("p", { children: o(n) }) : null] })] })] });
}, gi = I.div`
  pointer-events: none;
  position: absolute;
  left: 20px;
  top: 20px;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  border: 2px dashed rgba(255, 255, 255, 0.6);
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  border-radius: 12px;
`, yi = I.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  max-width: 420px;

  img {
    width: 120px;
    height: auto;
    clip-path: none;
    &.err-img {
      width: 132px;
    }
  }

  h3 {
    text-align: center;
    text-transform: uppercase;
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 23px;
    text-align: center;
    letter-spacing: 0.03em;
    opacity: 0.5;
  }
`, wi = ({ files: t, rejectedFilesList: n, uploadSteps: e, setUploadStep: r, setFiles: o, shareFile: i }) => {
  const a = [...t, ...n][0]?.[2], c = () => {
    o([]), r({ step: e.inactive, payload: null });
  };
  return a ? l(un, { children: M(st, { children: [l("div", { style: { flexGrow: 1 }, children: [...t, ...n].map(([d, s, u, m], f) => l(mi, { filename: d, error: s, file: u, uploaded: m, fileIndex: f, files: t, uploadSteps: e, setUploadStep: r, setFiles: o }, f)) }), M(at, { children: [l(ae, { label: "cancel", onClick: c }), l(ae, { label: "upload", isAsync: true, disabled: !t.filter(([d, s]) => !s).length > 0, onClick: async () => Promise.all([...t.map(async ([d, s, u]) => {
    if (!s)
      return await i(d, u);
  })]) })] })] }) }) : l(wn, { label: n?.[0] ? n[0] : "sorry-file-not-supported", isError: true, cancel: c });
}, xi = {};
function xn({ onDrop: t, maxFiles: n = 1 / 0, maxSize: e = 1 / 0, accept: r = xi, noClick: o, noKeyboard: i, setErrorDisplay: a = () => {
} }) {
  const [c, d] = /* @__PURE__ */ N(false), s = /* @__PURE__ */ Z(() => [], []), u = (p) => {
    p.preventDefault(), p.stopPropagation(), d(true);
  }, m = (p) => {
    p.preventDefault(), p.stopPropagation(), d(false);
  }, f = (p) => {
    p.preventDefault(), p.stopPropagation(), d(false), s.length = 0, a([]);
    const h = [];
    for (const y of p.dataTransfer.files) {
      let v;
      r instanceof Array && !r.includes(ft.lookup(y.name)) ? v = "sorry-file-not-supported" : y.size > e && (v = "sorry-file-too-large"), v ? (s.push(v), a([v])) : h.push(y);
    }
    typeof t == "function" && t(h.slice(0, n), s);
  };
  return { isDragActive: c, getRootProps: () => ({ onDragOver: u, onDragLeave: m, onDrop: f, onClick: o ? (p) => p.preventDefault() : null, onKeyDown: i ? (p) => p.preventDefault() : null, tabIndex: 0 }), getInputProps: () => ({}), rejectedFiles: s };
}
const G = { inactive: 0, pendingUpload: 1, fileEdit: 2, fileUploadAwaiting: 3, fileUploadProgess: 4, fileUploadFinished: 5 }, vi = ({ currentPlan: t }) => {
  const [n, e] = /* @__PURE__ */ N(0), [r, o] = /* @__PURE__ */ N({ step: G.inactive, payload: null }), [i, a] = /* @__PURE__ */ N([]), c = /* @__PURE__ */ j((P) => P.dom), d = /* @__PURE__ */ O(), s = /* @__PURE__ */ re();
  Bt(() => {
    if (c)
      return c.current.ondragenter = () => e(100), c.current.ondragend = () => e(0), c.current.ondrop = () => e(0), () => {
        c.current.ondragenter = null, c.current.ondragend = null, c.current.ondrop = null;
      };
  }, [c]);
  const u = /* @__PURE__ */ he(async (P, T) => {
    g("showSpinnerLoader", true);
    const k = s.playersMeshes[d.id], x = new _.Vector3(), C = new _.Vector3();
    k.getWorldPosition(x), k.getWorldDirection(C);
    const D = [x.x + C.x, x.y + C.y + 1, x.z + C.z];
    let w = i.slice(0);
    const F = /* @__PURE__ */ i.findIndex(([S]) => S === P);
    w[F][1] = null, w[F][3] = G.fileUploadProgess, a(w);
    try {
      const { success: S, fileId: U } = await pi(T, D, P, w[F][4] || { displayName: P, description: "" }), L = /* @__PURE__ */ Yn(`${U}`);
      w = i.slice(0), w[F][1] = null, w[F][3] = G.fileUploadFinished, a(w), g("showSpinnerLoader", false);
    } catch (S) {
      console.error("shareFile", "upload error", S), w = i.slice(0), w[F][1] = new Error("Upload unsuccessful."), w[F][3] = G.fileUploadFinished, a(w), g("showSpinnerLoader", false);
    }
  }, [d, i]);
  R(() => {
    if (!i?.length)
      return;
    i.reduce((T, k) => {
      const [, x, , C] = k;
      return T && !x && C === G.fileUploadFinished;
    }, true) && (a([]), o({ step: G.inactive, payload: null }));
  }, [i, r]);
  const m = /* @__PURE__ */ he((P, T) => {
    const k = [...P.map((x) => [x.name, null, null, G.fileUploadAwaiting]), ...T.map(([x, C]) => [x.name, C, null, G.fileUploadAwaiting])];
    a(k.slice(0)), P.forEach((x, C) => {
      const D = new FileReader();
      D.onabort = () => {
        k[C] = [x.name, new Error("File upload aborted"), null, G.fileUploadAwaiting], a(k.slice(0));
      }, D.onerror = () => {
        k[C] = [x.name, new Error("File upload error"), null, G.fileUploadAwaiting], a(k.slice(0));
      }, D.onload = async () => {
        const w = D.result;
        k[C] = [x.name, null, { file: x, data: w }, G.fileUploadAwaiting], a(k.slice(0));
      }, D.readAsArrayBuffer(x);
    }), k.length > 0 && o({ step: G.pendingUpload, payload: null });
  }), [f, p] = /* @__PURE__ */ N([]), h = t?.maxFileSizePerUpload * 1e6;
  B("dropFile", (P) => {
    P && (p([]), P.size > h ? (m([], ["sorry-file-too-large"]), p(["sorry-file-too-large"])) : m([P], []), e(100));
  });
  const { getRootProps: y, isDragActive: v } = /* @__PURE__ */ xn({ onDrop: m, setErrorDisplay: p, maxSize: h, maxFiles: 1, accept: ["image/gif", "image/png", "image/apng", "image/jpg", "image/jpeg", "image/avif", "image/webp", "application/pdf"], noClick: false, noKeyboard: false });
  R(() => {
    !v && r.step === G.inactive && e(0);
  }, [v, r]);
  const b = /* @__PURE__ */ Z(() => ({ [G.inactive]: l(wn, { label: "drop-to-upload", desc: "drop-to-upload-desc" }), [G.pendingUpload]: l(wi, { files: i, uploadStep: r, rejectedFilesList: f, uploadSteps: G, setUploadStep: o, setFiles: a, shareFile: u }) })[r.step], [r, i]);
  return n <= 0 ? null : l(it, { ...y(), style: { zIndex: n }, children: b });
}, bi = () => {
  const [t] = /* @__PURE__ */ j((o) => [o.sharedFileFocused]), n = /* @__PURE__ */ $(), e = /* @__PURE__ */ he((o) => {
    n.current && (n.current.style.top = `${o.pageY}px`, n.current.style.left = `${o.pageX}px`);
  }, [n.current]), r = /* @__PURE__ */ Z(() => {
    if (!t)
      return "";
    if (t.isLinkUrl) {
      const { linkTitle: o, linkUrl: i } = t.metadata || {};
      return M(H, { children: [o ? M("b", { children: [o, l("span", { children: ": " })] }) : null, i.substr(0, 32), i.length > 32 ? l("span", { children: "..." }) : null] });
    }
    return "";
  }, [t]);
  return R(() => {
    if (t)
      return window.addEventListener("pointermove", e), () => {
        window.removeEventListener("pointermove", e);
      };
  }, [t]), !t || !t.isLinkUrl ? null : l(ki, { ref: n, children: l(Pi, { children: r }) });
}, ki = I.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  z-index: 1;
  pointer-events: none;
  cursor: pointer;
`, Pi = I.div`
  position: relative;
  top: 8px;
  left: 4px;
  background-color: rgba(54, 54, 54, 0.6);
  padding: 8px 12px;
  color: #ffffff;
  border-radius: 12px;
  white-space: nowrap;
`, Ci = ({ renderPriority: t, hudScene: n }) => {
  const e = /* @__PURE__ */ J.useMemo(() => new _.Matrix4(), []), r = /* @__PURE__ */ J.useMemo(() => new Image(), []), o = /* @__PURE__ */ Ee((s) => s.size), i = new _.Vector3(), a = new _.Quaternion(), c = new _.Vector3(), d = /* @__PURE__ */ j((s) => s.askedScreenshot);
  return X(({ camera: s, gl: u }) => {
    if (!Zn().paused && d) {
      const { ref: m } = /* @__PURE__ */ O();
      if (!m)
        return;
      g("showSpinnerLoader", true);
      const f = m.api.getParent().current, p = 512;
      u.setSize(p, p, false), f.castShadow = false;
      const h = m.userData.id;
      f.getMatrixAt(h, e);
      const y = /* @__PURE__ */ e.toArray([]), v = [];
      for (let T = 0; T < f._inViewports.length; T++)
        f._inViewports[T] && T !== h && (v.push(T), f._inViewports[T] = false);
      f._inViewports[h] = true, e.compose(i.set(0, -p * 4, -p * 2), a.identity(), c.setScalar(p * 3)), s.near = 0.1, s.far = p * 5, s.left = -p, s.right = p, s.top = p, s.bottom = -p, s.updateProjectionMatrix(), f.setMatrixAt(h, e), f.skeleton && f.skeleton.boneTexture && (f.skeleton.boneTexture.needsUpdate = true), n.children = [f];
      const b = /* @__PURE__ */ _e.uniforms[3].value.toArray(), P = /* @__PURE__ */ _e.uniforms[1].value.toArray();
      _e.uniforms[1].value.set(1, 1, 1, 0.5), _e.uniforms[3].value.set(0, 1e4, 4e4, 0), u.clear(), u.render(n, s), _e.uniforms[1].value.fromArray(P), _e.uniforms[3].value.fromArray(b);
      for (let T = 0; T < v.length; T++) {
        const k = v[T];
        f._inViewports[k] = true;
      }
      f.setMatrixAt(h, e.fromArray(y)), f.castShadow = true, lt({ paused: true, screenshot: true }), r.src = u.domElement.toDataURL(), Fe({ profilePicture: r.src }), lt({ paused: false, screenshot: false }), u.setSize(o.width, o.height, false), A({ askedScreenshot: false }), g("screenshot", { imageUrl: r.src }), g("showSpinnerLoader", false);
    }
  }, t - 1), null;
};
function Si({ children: t, renderPriority: n = 1 }) {
  const [e] = /* @__PURE__ */ J.useState(() => new _.Scene());
  return l(H, { children: Rt(M(H, { children: [t, l(Ci, { hudScene: e, renderPriority: n })] }), e, { events: { priority: n + 1 } }) });
}
const Mi = () => De((n) => n.profilePicture) ? null : l(Si, { renderPriority: 10001, children: l(Dt, { makeDefault: true, position: [0, 0, 0] }) }), vn = ({ cls: t = "crnr" }) => l("svg", { className: t, width: "16", height: "11", viewBox: "0 0 16 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: l("path", { d: "M16 1H5.5C3.01472 1 1 3.01472 1 5.5V5.5C1 7.98528 3.01472 10 5.5 10H16", stroke: "white", strokeWidth: "1.2" }) }), _i = ({ label: t, action: n, tr: e = "common" }) => {
  const { t: r } = /* @__PURE__ */ Y(e);
  return M(Ii, { className: "lblbtn secfont", onClick: n, children: [l(vn, {}), r(t), l(vn, { cls: "crnr right" })] });
}, Ii = I.button`
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.04em;
  color: #fff;

  .right {
    transform: scaleX(-1) translate3d(0, 0, 0);
  }

  @media all and (pointer: fine) {
    svg {
      opacity: 0.5;
      transition: opacity 0.2s ease, transform 0.3s ease;
      transform: translate3d(0, 0, 0);
    }

    &:hover {
      svg {
        opacity: 1;
      }
      .crnr {
        transform: translate3d(-5px, 0, 0);
      }
      .crnr.right {
        transform: scaleX(-1) translate3d(-5px, 0, 0);
      }
    }
  }
`, Ai = ({ label: t, action: n, disable: e, tr: r = "office" }) => {
  const { t: o } = /* @__PURE__ */ Y(r);
  return l(Ti, { className: `secFontTxtSml ${e ? "disable" : ""}`, onClick: n, children: o(t) });
}, Ti = I.button`
  position: relative;
  text-transform: capitalize;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 100%;
    height: 1px;
    background: #fff;
  }

  &.disable {
    opacity: 0.5;
    pointer-events: none;
  }

  @media all and (pointer: fine) {
    &::before {
      transform: scale(1) translateZ(0);
      transition: transform 0.2s ease;
    }
    &:hover::before {
      transform: scale(0) translateZ(0);
    }
  }
`, Ei = 60 * 1e3, $i = 5 * 1e3, Di = (t) => {
  const n = new Ut(Math.random() * 8947848 + 8947848);
  return { pointer: { x: 0, y: 0 }, selectedElementIds: [], username: "Anonymous", color: { background: `#${n.getHexString()}`, stroke: "#ffffff" }, ...t };
}, Fi = ({ whiteboardId: t }) => {
  const n = /* @__PURE__ */ $(), [e, r] = /* @__PURE__ */ N(null), [o, i] = /* @__PURE__ */ N([900, 700]), a = /* @__PURE__ */ O(), c = document?.documentElement?.getAttribute("lang"), d = /* @__PURE__ */ $([]), [s, u] = /* @__PURE__ */ De((k) => [k.profilePicUid, k.hasProfilePic]), m = "/placeholder/profilepic.jpg", f = /* @__PURE__ */ $({}), p = /* @__PURE__ */ $({}), h = /* @__PURE__ */ $(null), y = async () => {
    const { microverseId: k, workspace: x } = /* @__PURE__ */ E(), C = await O().user?.getIdToken(), D = /* @__PURE__ */ se(x);
    if (!C || !n.current)
      return;
    const w = await fetch(`${D}/api/${k}/whiteboards/get`, { method: "POST", body: JSON.stringify({ whiteboardId: t }), headers: { authorization: `Bearer ${C}` } }), { success: F, whiteboard: S } = await w.json(), { updateScene: U } = n.current;
    F && (U({ elements: [...S.elements || []] }), S.elements.forEach((L) => {
      L.fileId && b(L.fileId);
    }), g("showSpinnerLoader", false));
  }, v = async (k, x) => {
    const { microverseId: C, workspace: D } = /* @__PURE__ */ E(), w = /* @__PURE__ */ se(D), F = await O().user.getIdToken(), S = await fetch(`${w}/api/${C}/whiteboards/upload-file`, { method: "POST", body: JSON.stringify({ whiteboardId: t, fileId: k }), headers: { authorization: `Bearer ${F}` } }), { url: U, fields: L } = await S.json(), q = new FormData();
    Object.entries({ ...L, file: x }).forEach(([Q, ue]) => {
      q.append(Q, ue);
    }), (await fetch(U, { method: "POST", body: q, mode: "cors" })).ok ? g("realtimeSendEventBroadcast", { eventType: "wbUpt", payload: { wbId: t, fileUpt: [k] } }) : console.error("Upload failed.");
  }, b = async (k) => {
    const { workspace: x, microverseId: C } = /* @__PURE__ */ E(), D = `https://storage.googleapis.com/konpi-app/${x}/${C}/whiteboards/${t}/${k}`;
    try {
      const F = await (await fetch(D, { method: "GET", headers: new Headers(), mode: "cors", cache: "default" })).json(), { addFiles: S } = n.current;
      S([F]);
    } catch {
    }
  }, P = async () => {
    if (!n.current) {
      h.current = setTimeout(() => {
        P();
      }, 5 * 1e3);
      return;
    }
    const { getSceneElements: k } = n.current, { microverseId: x, workspace: C } = /* @__PURE__ */ E(), D = /* @__PURE__ */ se(C), w = await O().user.getIdToken(), F = await fetch(`${D}/api/${x}/whiteboards/update`, { method: "POST", body: JSON.stringify({ whiteboardId: t, elements: [...k()] }), headers: { authorization: `Bearer ${w}` } }), { success: S } = await F.json();
    S || console.warn("Failed to update whiteboard server-side"), h.current = setTimeout(() => {
      P();
    }, $i);
  }, T = (k) => {
    if (!n.current)
      return;
    const { getAppState: x, updateScene: C } = n.current, { collaborators: D } = /* @__PURE__ */ x(), w = new Map(D);
    w.delete(k), C({ collaborators: w });
  };
  return R(() => {
    y();
  }, [n.current]), R(() => (import("@excalidraw/excalidraw").then((k) => {
    r(k.Excalidraw), g("showSpinnerLoader", true), P(), setTimeout(() => {
      i(([x, C]) => [x + 0.5, C + 0.5]);
    }, 2e3);
  }), () => {
    clearTimeout(h.current);
  }), []), B("wbUpt", (k) => {
    if (!n.current)
      return;
    const { wbId: x, colbId: C, colbUpt: D, elUpt: w, fileUpt: F } = k;
    if (x !== t)
      return;
    const { getAppState: S, updateScene: U, getSceneElementsIncludingDeleted: L, getFiles: q } = n.current, { collaborators: le } = /* @__PURE__ */ S(), Q = [...L()], ue = { ...q() || {} }, fe = new Map(le);
    let pe = false;
    if (C && D) {
      const K = fe.get(C) || {};
      if (delete D.avatarUrl, !K.avatarUrl) {
        const { userId: ve, profilePicUid: Se, hasProfilePic: Le } = D;
        try {
          D.avatarUrl = Xe(Le ? `${W.profilePicturePath + ve}/profile.webp${Se ? `?v=${Se}` : ""}` : m, m);
        } catch {
          D.avatarUrl = null;
        }
      }
      p.current[C] && clearTimeout(p.current[C]), p.current[C] = setTimeout(() => {
        T(C);
      }, Ei), fe.set(C, { ...K, ...D }), pe = true;
    }
    w && w.forEach((K) => {
      const ve = /* @__PURE__ */ Q.findIndex((Le) => Le?.id === K.id), Se = Q[ve];
      Se ? Se.version < K.version && (Q[ve] = K, pe = true) : (Q.push(K), K.fileId && !ue[K.fileId] && b(K.fileId), pe = true);
    }), F && b(F), pe && U({ collaborators: fe, elements: Q });
  }), l(Ui, { style: { width: o[0], height: o[1] }, children: e && l(e, { ref: n, isCollaborating: true, gridModeEnabled: true, viewModeEnabled: false, langCode: { ja: "ja-JP", fr: "fr-FR" }[c], onChange: (k, x, C) => {
    const D = [], { getSceneElementsIncludingDeleted: w } = n.current;
    [...w()].forEach((S) => {
      const U = d.current[S.id];
      if (S.fileId) {
        const L = S.fileId;
        S.status === "pending" && C[L] && (v(L, JSON.stringify(C[L])), S.status = "ready");
      }
      (!U || U.version < S.version) && D.push(S);
    }), D.forEach((S) => {
      f.current[S.id] >= S.version || (f.current[S.id] = S.version, g("realtimeSendEventBroadcast", { eventType: "wbUpt", payload: { wbId: t, colbId: a.id, elUpt: [S] } }));
    }), d.current = k;
  }, name: t, onPointerUpdate: ({ pointer: k, button: x }) => {
    if (!n.current)
      return;
    const { getAppState: C, updateScene: D } = n.current, { collaborators: w } = /* @__PURE__ */ C();
    let F = w.get(a.id), S = new Map(w);
    if (F || (F = Di({ username: a.name, userId: a.id, profilePicUid: s, hasProfilePic: u })), F.pointer = k, F.button = x, g("realtimeSendEventBroadcast", { eventType: "wbUpt", payload: { wbId: t, colbId: a.id, colbUpt: F } }), !F.avatarUrl)
      try {
        F.avatarUrl = Xe(u ? `${W.profilePicturePath + a.id}/profile.webp${s ? `?v=${s}` : ""}` : m, m);
      } catch {
      }
    S.set(a.id, F), D({ collaborators: S });
  } }) });
}, Ui = I.div`
  position: relative;
  display: block;
`;
export {
  ae as BorderButton,
  on as CharacterMessages,
  bo as CharactersManager,
  Ur as ControlsManager,
  Vr as ControlsManagerCanvas,
  vi as FileSharing,
  Qo as FileSharingEditPanel,
  di as FileSharingViewModal,
  bi as FileTooltip,
  co as HUDScene,
  fn as IconArrow,
  _i as LabelButton,
  we as LabelInput,
  nn as Player,
  pn as PostItSharingEditModal,
  Ge as RoundButton,
  ge as SCENE_AUDIO_LIST,
  Cr as SceneAudioManager,
  Do as SharedFiles,
  Ai as SimpleTextButton,
  Mi as SnapshotRenderer,
  mn as URLSharingEditModal,
  Fi as Whiteboard,
  Nt as addToGeneralChat,
  ee as assets,
  Co as decodeLocationHash,
  tt as domain,
  Po as encodeLocationHash,
  fr as getNonPlayersStore,
  re as getPlayersStore,
  br as getSceneAudioListOptions,
  je as getSocial,
  E as getStoreExperience,
  gr as getStoreHUD,
  se as getURLRoot,
  O as getUser,
  gt as inactivityDrag,
  Lt as initPlayerObject,
  wt as initPlayersByIds,
  oe as playerDidControl,
  ur as postMessageById,
  So as prettyBytes,
  nt as protocol,
  yt as refreshCharacters,
  pr as setNonPlayersStore,
  Ke as setPlayersStore,
  xr as setSocial,
  A as setStoreExperience,
  ke as setStoreHUD,
  Fe as setUser,
  Ue as signalPlayerUpdate,
  Sr as sit,
  rn as socialTunnel,
  ot as structuredCloneSafe,
  lr as teleportPlayerAnim,
  ce as unsit,
  Wt as useCharacterSkin,
  xn as useDropzone,
  hr as useNonPlayerObject,
  bt as useNonPlayersStore,
  Kt as usePlayerCharacterAnimations,
  jt as usePlayerObject,
  ne as usePlayersStore,
  qt as useSocial,
  Ze as useSocialStoreImpl,
  j as useStoreExperience,
  Ye as useStoreHUD,
  De as useUserStore,
  Ot as userDefaultSkins,
  zt as userDefaultValues
};
